import { jsx as a, jsxs as u, Fragment as X } from "react/jsx-runtime";
import q, { forwardRef as c, useCallback as k, useState as A, useRef as O, useEffect as H, createContext as Ie, useContext as Qe, cloneElement as et, useMemo as ke, Children as tt } from "react";
import { twMerge as rt } from "tailwind-merge";
import * as L from "@radix-ui/react-select";
import { ChevronDownIcon as Pe, CheckIcon as Ee, CalendarIcon as nt, ChevronLeftIcon as at, ChevronRightIcon as De, DotsHorizontalIcon as ot, DotFilledIcon as st, Cross2Icon as K, MagnifyingGlassIcon as Re, DragHandleDots2Icon as lt, RocketIcon as it, UploadIcon as dt, InfoCircledIcon as be, LightningBoltIcon as ct, CrossCircledIcon as mt, ExclamationTriangleIcon as _e, CheckCircledIcon as ut, ArrowLeftIcon as ft } from "@radix-ui/react-icons";
import * as xe from "@radix-ui/react-checkbox";
import * as _ from "@radix-ui/react-context-menu";
import * as I from "@radix-ui/react-popover";
import { DayPicker as pt } from "react-day-picker";
import { format as gt } from "date-fns";
import * as M from "@radix-ui/react-dropdown-menu";
import * as le from "@radix-ui/react-radio-group";
import * as te from "@radix-ui/react-slider";
import * as j from "@radix-ui/react-tabs";
import * as Ne from "@radix-ui/react-switch";
import * as P from "@radix-ui/react-dialog";
import * as G from "@radix-ui/react-toast";
import * as Y from "@radix-ui/react-accordion";
import { Music as ht, Check as bt, ChevronLeft as xt, ChevronRight as Nt } from "lucide-react";
import * as J from "@radix-ui/react-tooltip";
function Me(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (r = 0; r < o; r++) e[r] && (t = Me(e[r])) && (n && (n += " "), n += t);
  } else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function yt() {
  for (var e, r, t = 0, n = "", o = arguments.length; t < o; t++) (e = arguments[t]) && (r = Me(e)) && (n && (n += " "), n += r);
  return n;
}
function l(...e) {
  return rt(yt(e));
}
function de(e, r, t) {
  if (!e) return r[t];
  if (typeof e == "string") return r[e];
  const n = [];
  return e.base ? n.push(r[e.base]) : n.push(r[t]), e.sm && n.push(
    r[e.sm].split(" ").map((o) => `sm:${o}`).join(" ")
  ), e.md && n.push(
    r[e.md].split(" ").map((o) => `md:${o}`).join(" ")
  ), e.lg && n.push(
    r[e.lg].split(" ").map((o) => `lg:${o}`).join(" ")
  ), e.xl && n.push(
    r[e.xl].split(" ").map((o) => `xl:${o}`).join(" ")
  ), n.join(" ");
}
const z = c((e, r) => {
  const {
    variant: t = "primary",
    size: n = "md",
    shape: o = "rounded",
    className: s,
    children: i,
    disabled: d,
    ...m
  } = e;
  return /* @__PURE__ */ a(
    "button",
    {
      ref: r,
      disabled: d,
      "aria-disabled": d,
      className: l(
        "inline-flex font-medium items-center justify-center",
        wt[t],
        de(n, St, "md"),
        vt[o],
        "disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none",
        s
      ),
      ...m,
      children: i
    }
  );
});
z.displayName = "Button";
const vt = {
  square: "rounded-none",
  rounded: "rounded-md",
  pill: "rounded-full"
}, ye = "bg-button-primary text-button-text-inverse hover:bg-button-primary/90", wt = {
  primary: ye,
  default: ye,
  outline: "bg-transparent border-1 border-button-primary text-button-primary hover:bg-button-primary/10",
  secondary: "bg-background-secondary text-foreground",
  ghost: "bg-transparent text-foreground hover:bg-background-secondary",
  danger: "bg-button-destructive text-foreground"
}, St = {
  sm: "h-8 px-3 text-sm",
  md: "h-10 px-6",
  lg: "h-12 px-8 text-lg",
  icon: "h-9 w-9 p-0"
}, Ct = c((e, r) => {
  const {
    options: t,
    value: n,
    onChange: o,
    maxSelections: s,
    disabled: i = !1,
    size: d = "md",
    className: m,
    "aria-label": f = "Chip selection",
    ...p
  } = e, h = k(
    (N) => {
      if (i) return;
      if (n.includes(N))
        o(n.filter((x) => x !== N));
      else {
        if (s && n.length >= s) return;
        o([...n, N]);
      }
    },
    [i, n, o, s]
  ), b = !s || n.length < s;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      role: "group",
      "aria-label": f,
      className: l("flex flex-wrap gap-2", m),
      ...p,
      children: t.map((N) => {
        const g = n.includes(N.value);
        return /* @__PURE__ */ a(
          ze,
          {
            selected: g,
            disabled: i || !g && !b,
            size: d,
            onClick: () => h(N.value),
            "aria-pressed": g,
            children: N.label
          },
          N.value
        );
      })
    }
  );
});
Ct.displayName = "ChipSelect";
const ze = c((e, r) => {
  const { selected: t = !1, size: n = "md", disabled: o, className: s, children: i, ...d } = e;
  return /* @__PURE__ */ a(
    "button",
    {
      ref: r,
      type: "button",
      disabled: o,
      className: l(
        "inline-flex items-center rounded-full font-medium transition-colors",
        "border focus:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring",
        At(n),
        t ? "bg-button-primary border-button-primary text-button-primary-fg" : "bg-background-secondary border-border text-foreground hover:bg-hover-overlay",
        o && "opacity-50 cursor-not-allowed",
        s
      ),
      ...d,
      children: i
    }
  );
});
ze.displayName = "Chip";
const Tt = {
  sm: "px-2.5 py-1 text-xs",
  md: "px-3 py-1.5 text-sm",
  lg: "px-4 py-2 text-base"
};
function At(e) {
  return Tt[e];
}
const It = c((e, r) => {
  const { variant: t, size: n, underline: o, className: s, children: i, ...d } = e;
  return /* @__PURE__ */ a(
    "a",
    {
      ref: r,
      className: l(
        "inline-flex items-center font-medium transition-colors",
        Pt(t),
        Dt(n),
        _t(o),
        s
      ),
      ...d,
      children: i
    }
  );
});
It.displayName = "Link";
const kt = {
  default: "text-blue-600 hover:text-blue-700",
  muted: "text-gray-600 hover:text-gray-900",
  nav: "text-gray-700 hover:text-gray-900",
  danger: "text-red-600 hover:text-red-700"
};
function Pt(e) {
  return kt[e || "default"];
}
const Et = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg"
};
function Dt(e) {
  return Et[e || "md"];
}
const Rt = {
  always: "underline",
  hover: "hover:underline",
  none: "no-underline"
};
function _t(e) {
  return Rt[e || "hover"];
}
const Mt = c((e, r) => {
  const { variant: t, size: n, className: o, children: s, ...i } = e;
  return /* @__PURE__ */ a(
    "button",
    {
      ref: r,
      className: l(
        "hover:bg-hover-overlay inline-flex items-center justify-center rounded-md font-medium p-1",
        Lt(t),
        o
      ),
      ...i,
      children: /* @__PURE__ */ a(Ke, { size: n, children: s })
    }
  );
});
Mt.displayName = "IconButton";
const zt = {
  primary: "bg-button-primary text-button-text-inverse hover:bg-button-primary/90",
  default: "bg-button-primary text-button-text-inverse hover:bg-button-primary/90",
  secondary: "bg-background-secondary text-foreground hover:bg-hover-overlay",
  ghost: "",
  danger: "bg-button-destructive text-foreground hover:bg-button-destructive/90",
  outline: "border border-border bg-transparent text-foreground hover:bg-hover-overlay"
};
function Lt(e) {
  return zt[e || "ghost"];
}
const Ot = {
  default: "border border-border-secondary bg-background-secondary text-foreground",
  ghost: "border-transparent bg-transparent text-foreground"
}, Vt = {
  sm: "h-8 px-2 text-sm",
  md: "h-10 px-3 text-base",
  lg: "h-12 px-4 text-lg"
}, Ft = c((e, r) => {
  const { variant: t = "default", size: n = "md", focusable: o = !0, className: s, ...i } = e;
  return /* @__PURE__ */ a(
    "input",
    {
      ref: r,
      className: l(
        "rounded-md transition-colors w-full",
        o ? "focus:outline-none focus:ring-2 focus:ring-button-primary focus:ring-offset-1 focus:ring-offset-background" : "focus:outline-none focus:ring-0 focus:ring-transparent",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "placeholder:text-foreground-muted",
        "hover:border-border-secondary",
        Ot[t],
        de(n, Vt, "md"),
        s
      ),
      ...i
    }
  );
});
Ft.displayName = "Input";
const Le = c((e, r) => {
  const {
    variant: t = "default",
    size: n = "md",
    placeholder: o = "Select an option",
    className: s,
    children: i,
    ...d
  } = e;
  return /* @__PURE__ */ u(L.Root, { ...d, children: [
    /* @__PURE__ */ u(
      L.Trigger,
      {
        ref: r,
        className: l(
          "w-full inline-flex items-center justify-between rounded-md font-medium transition-colors",
          "outline-none focus-visible:ring-2 focus-visible:ring-focus-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
          "disabled:cursor-not-allowed disabled:opacity-50",
          Bt[t],
          de(n, Gt, "md"),
          s
        ),
        children: [
          /* @__PURE__ */ a(L.Value, { placeholder: o }),
          /* @__PURE__ */ a(L.Icon, { children: /* @__PURE__ */ a(Pe, {}) })
        ]
      }
    ),
    /* @__PURE__ */ a(L.Portal, { children: /* @__PURE__ */ a(
      L.Content,
      {
        className: l(
          "max-h-[300px] overflow-auto outline-none",
          "min-w-[var(--radix-select-trigger-width)]",
          "w-full overflow-hidden rounded-md shadow-lg",
          "bg-surface-elevated border border-border",
          "text-foreground"
        ),
        position: "popper",
        sideOffset: 4,
        align: "start",
        collisionPadding: 8,
        children: /* @__PURE__ */ a(L.Viewport, { className: "p-1 outline-none", children: i })
      }
    ) })
  ] });
});
Le.displayName = "Select";
const Oe = c(
  ({ className: e, children: r, ...t }, n) => /* @__PURE__ */ a(
    L.Item,
    {
      ref: n,
      className: l(
        "w-full relative flex items-center rounded px-2 py-1.5 text-sm",
        "select-none outline-none",
        "text-foreground-muted",
        "data-[highlighted]:bg-surface-overlay data-[highlighted]:text-foreground",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        e
      ),
      ...t,
      children: /* @__PURE__ */ a(L.ItemText, { children: r })
    }
  )
);
Oe.displayName = "SelectItem";
const jt = c(
  ({ className: e, children: r, ...t }, n) => /* @__PURE__ */ a(
    L.Group,
    {
      ref: n,
      className: l("py-1", "border-t border-border first:border-t-0", e),
      ...t,
      children: r
    }
  )
);
jt.displayName = "SelectGroup";
const Ht = c(
  ({ className: e, children: r, ...t }, n) => /* @__PURE__ */ a(
    L.Label,
    {
      ref: n,
      className: l(
        "px-2 py-2 text-xs font-semibold text-foreground uppercase tracking-wider",
        e
      ),
      ...t,
      children: r
    }
  )
);
Ht.displayName = "SelectLabel";
const Bt = {
  default: "bg-background-secondary border border-border text-foreground hover:border-border-secondary",
  secondary: "bg-background border border-border-secondary text-foreground hover:border-border"
}, Gt = {
  sm: "h-8 px-3 text-sm",
  md: "h-10 px-4",
  lg: "h-12 px-6 text-lg"
}, Ve = c((e, r) => {
  const { className: t, size: n, ...o } = e;
  return /* @__PURE__ */ a(
    xe.Root,
    {
      ref: r,
      className: l(
        "peer shrink-0 rounded border border-foreground-muted/50 bg-transparent text-foreground-inverse",
        "relative before:absolute before:-inset-2 before:content-['']",
        // Touch target extension
        "ring-offset-white focus-visible:outline-none focus-visible:ring-2",
        "focus-visible:ring-focus-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:bg-foreground-accent data-[state=checked]:border-foreground-accent",
        Zt(n),
        t
      ),
      ...o,
      children: /* @__PURE__ */ a(xe.Indicator, { className: "flex items-center justify-center ", children: /* @__PURE__ */ a(Ee, { className: Kt(n) }) })
    }
  );
});
Ve.displayName = "Checkbox";
const $t = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6"
};
function Zt(e) {
  return $t[e || "md"];
}
const Ut = {
  sm: "h-3 w-3",
  md: "h-4 w-4",
  lg: "h-5 w-5"
};
function Kt(e) {
  return Ut[e || "md"];
}
const is = _.Root, ds = _.Trigger, cs = _.Group, ms = _.Sub, us = _.RadioGroup, Wt = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(_.Portal, { children: /* @__PURE__ */ a(
    _.Content,
    {
      ref: r,
      className: l(
        "z-50 min-w-[8rem] overflow-hidden rounded-md border border-border",
        "bg-surface-elevated p-1 shadow-md",
        "animate-in fade-in-80 data-[side=bottom]:slide-in-from-top-2",
        "data-[side=top]:slide-in-from-bottom-2",
        t
      ),
      ...n
    }
  ) });
});
Wt.displayName = "ContextMenuContent";
const Xt = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    _.Item,
    {
      ref: r,
      className: l(
        "relative flex cursor-pointer select-none items-center rounded px-2 py-1.5 text-sm",
        "outline-none transition-colors",
        "data-[highlighted]:bg-hover-overlay",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        t
      ),
      ...n
    }
  );
});
Xt.displayName = "ContextMenuItem";
const qt = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    _.Separator,
    {
      ref: r,
      className: l("-mx-1 my-1 h-px bg-border", t),
      ...n
    }
  );
});
qt.displayName = "ContextMenuSeparator";
const Yt = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    _.Label,
    {
      ref: r,
      className: l("px-2 py-1.5 text-sm font-semibold text-foreground-muted", t),
      ...n
    }
  );
});
Yt.displayName = "ContextMenuLabel";
const Jt = c((e, r) => {
  const { className: t, children: n, ...o } = e;
  return /* @__PURE__ */ a(
    _.SubTrigger,
    {
      ref: r,
      className: l(
        "relative flex cursor-pointer select-none items-center rounded px-2 py-1.5 text-sm",
        "outline-none transition-colors",
        "data-[highlighted]:bg-hover-overlay",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        t
      ),
      ...o,
      children: n
    }
  );
});
Jt.displayName = "ContextMenuSubTrigger";
const Qt = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(_.Portal, { children: /* @__PURE__ */ a(
    _.SubContent,
    {
      ref: r,
      className: l(
        "z-50 min-w-[8rem] overflow-hidden rounded-md border border-border",
        "bg-surface-elevated p-1 shadow-md",
        "animate-in data-[side=right]:slide-in-from-left-2",
        "data-[side=left]:slide-in-from-right-2",
        t
      ),
      ...n
    }
  ) });
});
Qt.displayName = "ContextMenuSubContent";
const er = c((e, r) => {
  const { value: t, onChange: n, placeholder: o = "Select date", className: s } = e, [i, d] = A(!1);
  return /* @__PURE__ */ u(I.Root, { open: i, onOpenChange: d, children: [
    /* @__PURE__ */ a(I.Trigger, { asChild: !0, children: /* @__PURE__ */ u(
      z,
      {
        ref: r,
        variant: "secondary",
        className: l(
          "justify-start text-left font-normal",
          !t && "text-gray-500",
          s
        ),
        children: [
          /* @__PURE__ */ a(nt, { className: "mr-2 h-4 w-4" }),
          t ? gt(t, "PPP") : o
        ]
      }
    ) }),
    /* @__PURE__ */ a(I.Portal, { children: /* @__PURE__ */ a(
      I.Content,
      {
        className: "w-auto p-0 bg-white rounded-md shadow-lg border border-gray-200",
        align: "start",
        children: /* @__PURE__ */ a(
          pt,
          {
            mode: "single",
            selected: t,
            onSelect: (m) => {
              n?.(m), d(!1);
            },
            className: "p-3"
          }
        )
      }
    ) })
  ] });
});
er.displayName = "DatePicker";
const fs = M.Root, ps = M.Trigger, gs = M.Group, hs = M.Sub, bs = M.RadioGroup, tr = c((e, r) => {
  const { className: t, sideOffset: n = 4, ...o } = e;
  return /* @__PURE__ */ a(M.Portal, { children: /* @__PURE__ */ a(
    M.Content,
    {
      ref: r,
      sideOffset: n,
      className: l(
        "z-50 min-w-[8rem] overflow-hidden rounded-md border border-border",
        "bg-surface-elevated p-1 shadow-md",
        "animate-in data-[side=bottom]:slide-in-from-top-2",
        "data-[side=top]:slide-in-from-bottom-2",
        t
      ),
      ...o
    }
  ) });
});
tr.displayName = "DropdownMenuContent";
const rr = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    M.Item,
    {
      ref: r,
      className: l(
        "relative flex cursor-pointer select-none items-center rounded px-2 py-1.5 text-sm",
        "outline-none transition-colors",
        "data-[highlighted]:bg-hover-overlay",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        t
      ),
      ...n
    }
  );
});
rr.displayName = "DropdownMenuItem";
const nr = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    M.Separator,
    {
      ref: r,
      className: l("-mx-1 my-1 h-px bg-border", t),
      ...n
    }
  );
});
nr.displayName = "DropdownMenuSeparator";
const ar = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    M.Label,
    {
      ref: r,
      className: l("px-2 py-1.5 text-sm font-semibold hover:bg-foreground-muted/50", t),
      ...n
    }
  );
});
ar.displayName = "DropdownMenuLabel";
const or = c((e, r) => {
  const { className: t, children: n, ...o } = e;
  return /* @__PURE__ */ a(
    M.SubTrigger,
    {
      ref: r,
      className: l(
        "relative flex cursor-pointer select-none items-center rounded px-2 py-1.5 text-sm",
        "outline-none transition-colors",
        "data-[highlighted]:bg-hover-overlay",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        t
      ),
      ...o,
      children: n
    }
  );
});
or.displayName = "DropdownMenuSubTrigger";
const sr = c((e, r) => {
  const { className: t, sideOffset: n = 2, alignOffset: o = -5, ...s } = e;
  return /* @__PURE__ */ a(M.Portal, { children: /* @__PURE__ */ a(
    M.SubContent,
    {
      ref: r,
      sideOffset: n,
      alignOffset: o,
      className: l(
        "z-50 min-w-[8rem] overflow-hidden rounded-md border border-border",
        "bg-surface-elevated p-1 shadow-md",
        "animate-in data-[side=right]:slide-in-from-left-2",
        "data-[side=left]:slide-in-from-right-2",
        t
      ),
      ...s
    }
  ) });
});
sr.displayName = "DropdownMenuSubContent";
const lr = c((e, r) => {
  const {
    value: t,
    onChange: n,
    options: o,
    placeholder: s = "Select option...",
    searchPlaceholder: i = "Search...",
    emptyMessage: d = "No results found.",
    disabled: m,
    className: f,
    ...p
  } = e, [h, b] = A(!1), [N, g] = A(""), [x, w] = A(0), T = O(null), E = o.find((S) => S.value === t), v = o.filter(
    (S) => S.label.toLowerCase().includes(N.toLowerCase())
  );
  H(() => {
    h && T.current && T.current.focus();
  }, [h]);
  const y = (S) => {
    if (h)
      switch (S.key) {
        case "ArrowDown":
          S.preventDefault(), w((C) => C < v.length - 1 ? C + 1 : C);
          break;
        case "ArrowUp":
          S.preventDefault(), w((C) => C > 0 ? C - 1 : C);
          break;
        case "Enter":
          S.preventDefault(), v[x] && !v[x].disabled && (n?.(v[x].value), b(!1), g(""));
          break;
        case "Escape":
          S.preventDefault(), b(!1), g("");
          break;
      }
  };
  return /* @__PURE__ */ u(I.Root, { open: h, onOpenChange: b, children: [
    /* @__PURE__ */ a(I.Trigger, { asChild: !0, children: /* @__PURE__ */ u(
      z,
      {
        ref: r,
        variant: "outline",
        role: "combobox",
        "aria-expanded": h,
        "aria-haspopup": "listbox",
        disabled: m,
        className: l(
          "w-full justify-between font-normal",
          !E && "text-foreground-muted",
          f
        ),
        ...p,
        children: [
          E ? E.label : s,
          /* @__PURE__ */ a(Pe, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })
        ]
      }
    ) }),
    /* @__PURE__ */ u(
      I.Content,
      {
        className: "w-[var(--radix-popover-trigger-width)] p-0 bg-surface-elevated rounded-md shadow-md border border-border",
        onOpenAutoFocus: (S) => S.preventDefault(),
        children: [
          /* @__PURE__ */ a("div", { className: "border-b", children: /* @__PURE__ */ a(
            "input",
            {
              ref: T,
              placeholder: i,
              value: N,
              onChange: (S) => {
                g(S.target.value), w(0);
              },
              onKeyDown: y,
              className: "h-9 w-full border-0 bg-transparent px-3 py-2 text-sm outline-none placeholder:text-foreground-muted"
            }
          ) }),
          /* @__PURE__ */ a("div", { className: "max-h-60 overflow-auto p-1", role: "listbox", "aria-label": "Options", children: v.length === 0 ? /* @__PURE__ */ a("div", { className: "py-6 text-center text-sm text-foreground-muted", children: d }) : v.map((S, C) => /* @__PURE__ */ u(
            "div",
            {
              role: "option",
              "aria-selected": t === S.value,
              "aria-disabled": S.disabled,
              onClick: () => {
                S.disabled || (n?.(S.value), b(!1), g(""));
              },
              onMouseEnter: () => w(C),
              className: l(
                "relative flex cursor-pointer select-none items-center rounded px-2 py-1.5 text-sm",
                "outline-none transition-colors",
                x === C && "bg-hover-overlay",
                S.disabled && "pointer-events-none opacity-50"
              ),
              children: [
                /* @__PURE__ */ a(
                  Ee,
                  {
                    className: l(
                      "mr-2 h-4 w-4",
                      t === S.value ? "opacity-100" : "opacity-0"
                    )
                  }
                ),
                S.label
              ]
            },
            S.value
          )) })
        ]
      }
    )
  ] });
});
lr.displayName = "Combobox";
const ir = c((e, r) => {
  const {
    value: t,
    onChange: n,
    onSelect: o,
    suggestions: s,
    placeholder: i = "Type to search...",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    emptyMessage: d,
    className: m,
    ...f
  } = e, [p, h] = A(!1), [b, N] = A(t || ""), [g, x] = A(0), w = s.filter(
    (v) => v.toLowerCase().includes(b.toLowerCase())
  ), T = (v) => {
    N(v), n?.(v), o?.(v), h(!1);
  }, E = (v) => {
    switch (v.key) {
      case "ArrowDown":
        v.preventDefault(), h(!0), x((y) => y < w.length - 1 ? y + 1 : 0);
        break;
      case "ArrowUp":
        v.preventDefault(), x((y) => y > 0 ? y - 1 : w.length - 1);
        break;
      case "Enter":
        p && w[g] && (v.preventDefault(), T(w[g]));
        break;
      case "Escape":
        h(!1);
        break;
    }
  };
  return /* @__PURE__ */ u(I.Root, { open: p && w.length > 0, children: [
    /* @__PURE__ */ a(I.Anchor, { asChild: !0, children: /* @__PURE__ */ a(
      "input",
      {
        ref: r,
        type: "text",
        value: b,
        onChange: (v) => {
          N(v.target.value), n?.(v.target.value), h(!0), x(0);
        },
        onFocus: () => h(!0),
        onBlur: () => setTimeout(() => h(!1), 200),
        onKeyDown: E,
        placeholder: i,
        className: l(
          "w-full rounded-md border border-border px-3 py-2",
          "focus:border-focus-ring focus:outline-none focus:ring-2",
          "focus:ring-focus-ring focus:ring-offset-2",
          "disabled:cursor-not-allowed disabled:opacity-50",
          m
        ),
        ...f
      }
    ) }),
    /* @__PURE__ */ a(
      I.Content,
      {
        className: "w-[var(--radix-popover-trigger-width)] p-1 bg-surface-elevated rounded-md shadow-md border border-border",
        onOpenAutoFocus: (v) => v.preventDefault(),
        children: /* @__PURE__ */ a("div", { className: "max-h-60 overflow-auto", children: w.map((v, y) => /* @__PURE__ */ a(
          "div",
          {
            onClick: () => T(v),
            onMouseEnter: () => x(y),
            className: l(
              "cursor-pointer rounded px-2 py-1.5 text-sm",
              "transition-colors",
              g === y && "bg-hover-overlay"
            ),
            children: v
          },
          v
        )) })
      }
    )
  ] });
});
ir.displayName = "Autocomplete";
const dr = c((e, r) => {
  const {
    accept: t,
    multiple: n = !1,
    disabled: o = !1,
    maxSize: s,
    onFilesSelected: i,
    onFileError: d,
    className: m,
    children: f
  } = e, p = O(null), [h, b] = A(!1), N = () => {
    o || p.current?.click();
  }, g = (y) => {
    if (!s) return y;
    const S = [];
    for (const C of y)
      C.size > s ? d?.(new Error(`${C.name} exceeds maximum size of ${s / 1024 / 1024}MB`)) : S.push(C);
    return S;
  }, x = (y) => {
    if (!y || y.length === 0) return;
    const S = Array.from(y), C = g(S);
    C.length > 0 && i?.(C);
  };
  return /* @__PURE__ */ u(
    "div",
    {
      onDrop: (y) => {
        y.preventDefault(), y.stopPropagation(), b(!1), !o && x(y.dataTransfer.files);
      },
      onDragOver: (y) => {
        y.preventDefault(), y.stopPropagation(), o || b(!0);
      },
      onDragLeave: (y) => {
        y.preventDefault(), y.stopPropagation();
        const S = y.currentTarget.getBoundingClientRect(), C = y.clientX, he = y.clientY;
        (C <= S.left || C >= S.right || he <= S.top || he >= S.bottom) && b(!1);
      },
      className: m,
      "data-dragging": h,
      "data-disabled": o,
      children: [
        /* @__PURE__ */ a(
          "input",
          {
            ref: p,
            type: "file",
            accept: t,
            multiple: n,
            onChange: (y) => {
              x(y.target.files), y.target.value = "";
            },
            disabled: o,
            className: "hidden",
            "aria-hidden": "true"
          }
        ),
        typeof f == "function" ? f({ isDragging: h, openFileDialog: N }) : null
      ]
    }
  );
});
dr.displayName = "FileUpload";
const cr = c((e, r) => {
  const {
    currentPage: t,
    totalPages: n,
    onPageChange: o,
    siblingCount: s = 1,
    showEdges: i = !0,
    className: d,
    ...m
  } = e, f = ur(t, n, s, i);
  return /* @__PURE__ */ u(
    "nav",
    {
      ref: r,
      role: "navigation",
      "aria-label": "Pagination",
      className: l("flex items-center space-x-1", d),
      ...m,
      children: [
        /* @__PURE__ */ a(
          Fe,
          {
            onClick: () => o(t - 1),
            disabled: t <= 1
          }
        ),
        f.map((p, h) => p === "dots" ? /* @__PURE__ */ a(mr, {}, `dots-${h}`) : /* @__PURE__ */ a(
          He,
          {
            page: p,
            isActive: t === p,
            onClick: () => o(p)
          },
          p
        )),
        /* @__PURE__ */ a(
          je,
          {
            onClick: () => o(t + 1),
            disabled: t >= n
          }
        )
      ]
    }
  );
});
cr.displayName = "Pagination";
const Fe = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ u(z, { ref: r, variant: "ghost", size: "sm", className: l("gap-1", t), ...n, children: [
      /* @__PURE__ */ a(at, { className: "h-4 w-4" }),
      /* @__PURE__ */ a("span", { className: "sr-only sm:not-sr-only", children: "Previous" })
    ] });
  }
);
Fe.displayName = "PaginationPrevious";
const je = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ u(z, { ref: r, variant: "ghost", size: "sm", className: l("gap-1", t), ...n, children: [
      /* @__PURE__ */ a("span", { className: "sr-only sm:not-sr-only", children: "Next" }),
      /* @__PURE__ */ a(De, { className: "h-4 w-4" })
    ] });
  }
);
je.displayName = "PaginationNext";
const He = c((e, r) => {
  const { page: t, isActive: n, onClick: o } = e;
  return /* @__PURE__ */ a(
    z,
    {
      ref: r,
      variant: n ? "primary" : "ghost",
      size: "sm",
      onClick: o,
      className: "min-w-[2rem]",
      children: t
    }
  );
});
He.displayName = "PaginationItem";
const mr = () => /* @__PURE__ */ a("span", { className: "flex h-8 w-8 items-center justify-center", children: /* @__PURE__ */ a(ot, { className: "h-4 w-4 text-gray-400" }) });
function ur(e, r, t, n) {
  if (r <= 7)
    return Array.from({ length: r }, (d, m) => m + 1);
  const o = [];
  n && o.push(1);
  const s = Math.max(n ? 2 : 1, e - t), i = Math.min(n ? r - 1 : r, e + t);
  s > (n ? 2 : 1) && o.push("dots");
  for (let d = s; d <= i; d++)
    o.push(d);
  return i < (n ? r - 1 : r) && o.push("dots"), n && i < r && o.push(r), o;
}
const fr = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(le.Root, { ref: r, className: l("grid gap-2", t), ...n });
  }
);
fr.displayName = "RadioGroup";
const pr = c((e, r) => {
  const { className: t, size: n, ...o } = e;
  return /* @__PURE__ */ a(
    le.Item,
    {
      ref: r,
      className: l(
        "aspect-square rounded-full border border-gray-300 bg-white",
        "ring-offset-white focus:outline-none focus-visible:ring-2",
        "focus-visible:ring-blue-500 focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:border-blue-600",
        hr(n),
        t
      ),
      ...o,
      children: /* @__PURE__ */ a(le.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ a(st, { className: l("text-blue-600", xr(n)) }) })
    }
  );
});
pr.displayName = "RadioGroupItem";
const gr = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6"
};
function hr(e) {
  return gr[e || "md"];
}
const br = {
  sm: "h-2 w-2",
  md: "h-2.5 w-2.5",
  lg: "h-3 w-3"
};
function xr(e) {
  return br[e || "md"];
}
const Nr = c((e, r) => {
  const {
    onSearch: t,
    onClear: n,
    showClearButton: o = !0,
    showSearchIcon: s = !0,
    className: i,
    value: d,
    onChange: m,
    onKeyDown: f,
    placeholder: p = "Search...",
    ...h
  } = e, [b, N] = A(""), g = d !== void 0, x = g ? d : b, w = (y) => {
    g || N(y.target.value), m?.(y);
  }, T = () => {
    g || N(""), n?.(), t?.("");
  }, E = (y) => {
    y.key === "Enter" && t?.(x), y.key === "Escape" && T(), f?.(y);
  }, v = !!(x && x !== "");
  return /* @__PURE__ */ u(B, { className: l("relative w-full"), children: [
    /* @__PURE__ */ a(
      "input",
      {
        ref: r,
        type: "text",
        value: x,
        onChange: w,
        onKeyDown: E,
        placeholder: p,
        className: l(
          "w-full rounded-lg",
          // rounded-lg for softer corners
          "border border-white/10",
          // subtle border for dark theme
          "bg-white/5",
          // semi-transparent background
          "px-4 py-2.5",
          // better padding
          "text-sm text-white/90",
          // white text
          "placeholder:text-white/40",
          // dimmed placeholder
          "transition-all duration-200",
          "hover:bg-white/10",
          // hover state
          "focus:bg-white/10 focus:border-white/20",
          // focus state
          "focus:outline-none focus:ring-1 focus:ring-white/20",
          "disabled:cursor-not-allowed disabled:opacity-50",
          s && "pr-10",
          // adjust for icon
          o && v && "pr-15",
          // make room for the clear button
          i
        ),
        ...h
      }
    ),
    /* @__PURE__ */ a("div", { className: "absolute right-3 top-1/2 -translate-y-1/2", children: v ? /* @__PURE__ */ a(
      "button",
      {
        type: "button",
        onClick: T,
        className: "text-white/40 hover:text-white/60 transition-colors",
        children: /* @__PURE__ */ a(K, { className: "h-4 w-4" })
      }
    ) : /* @__PURE__ */ a("div", { className: "pointer-events-none text-white/40", children: /* @__PURE__ */ a(Re, { className: "h-4 w-4" }) }) })
  ] });
});
Nr.displayName = "SearchInput";
const yr = {
  sm: "px-2 py-1 text-xs gap-1",
  md: "px-3 py-1.5 text-sm gap-1.5"
}, vr = {
  primary: {
    track: "bg-background-secondary",
    selected: "bg-surface-elevated text-foreground shadow-sm"
  },
  secondary: {
    track: "bg-background",
    selected: "bg-background-accent text-foreground shadow-sm"
  }
}, Be = c((e, r) => {
  const {
    value: t,
    onValueChange: n,
    options: o,
    size: s = "md",
    surface: i = "primary",
    disabled: d,
    fullWidth: m,
    className: f,
    ...p
  } = e, h = vr[i];
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l(
        "inline-flex rounded-md p-0.5",
        h.track,
        m && "w-full",
        f
      ),
      ...p,
      children: o.map((b) => {
        const N = t === b.value, g = d || b.disabled;
        return /* @__PURE__ */ a(
          "button",
          {
            type: "button",
            onClick: () => !g && n(b.value),
            disabled: g,
            className: l(
              "inline-flex items-center justify-center rounded transition-colors",
              yr[s],
              m && "flex-1",
              N ? h.selected : "text-foreground-muted hover:text-foreground",
              g && "opacity-50 cursor-not-allowed"
            ),
            children: b.label
          },
          b.value
        );
      })
    }
  );
});
Be.displayName = "SegmentedControl";
const wr = c((e, r) => {
  const { className: t, variant: n, size: o, ...s } = e;
  return /* @__PURE__ */ u(
    te.Root,
    {
      ref: r,
      className: l("relative flex w-full touch-none select-none items-center", t),
      ...s,
      children: [
        /* @__PURE__ */ a(
          te.Track,
          {
            className: l(
              "relative w-full grow overflow-hidden rounded-full bg-gray-200",
              Ar(o)
            ),
            children: /* @__PURE__ */ a(te.Range, { className: l("absolute h-full", Cr(n)) })
          }
        ),
        /* @__PURE__ */ a(
          te.Thumb,
          {
            className: l(
              "block rounded-full border-2 border-white bg-white shadow-lg ring-offset-white",
              "transition-colors focus-visible:outline-none focus-visible:ring-2",
              "focus-visible:ring-blue-500 focus-visible:ring-offset-2",
              "disabled:pointer-events-none disabled:opacity-50",
              kr(o)
            )
          }
        )
      ]
    }
  );
});
wr.displayName = "Slider";
const Sr = {
  default: "bg-blue-600",
  secondary: "bg-gray-600",
  success: "bg-green-600",
  danger: "bg-red-600"
};
function Cr(e) {
  return Sr[e || "default"];
}
const Tr = {
  sm: "h-1",
  md: "h-2",
  lg: "h-3"
};
function Ar(e) {
  return Tr[e || "md"];
}
const Ir = {
  sm: "h-3 w-3",
  md: "h-4 w-4",
  lg: "h-5 w-5"
};
function kr(e) {
  return Ir[e || "md"];
}
const xs = j.Root, Pr = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      j.List,
      {
        ref: r,
        className: l("flex w-full items-center gap-8", "border-b border-border", t),
        ...n
      }
    );
  }
);
Pr.displayName = "TabsList";
const Er = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      j.Trigger,
      {
        ref: r,
        className: l(
          "relative pb-3 text-md font-medium",
          "text-foreground-muted transition-colors",
          "hover:text-foreground",
          "data-[state=active]:text-foreground-accent",
          // Active indicator line
          "after:absolute after:bottom-0 after:left-0 after:right-0",
          "after:h-[4px] after:bg-foreground-accent",
          "after:scale-x-0 data-[state=active]:after:scale-x-100",
          "after:transition-transform after:duration-200",
          "focus-visible:outline-none",
          "disabled:pointer-events-none disabled:opacity-50",
          t
        ),
        ...n
      }
    );
  }
);
Er.displayName = "TabsTrigger";
const Dr = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      j.Content,
      {
        ref: r,
        className: l("pt-6", "focus-visible:outline-none", t),
        ...n
      }
    );
  }
);
Dr.displayName = "TabsContent";
const Ge = c((e, r) => {
  const { variant: t, size: n, onRemove: o, removable: s = !1, className: i, children: d, ...m } = e;
  return /* @__PURE__ */ u(
    "span",
    {
      ref: r,
      className: l(
        "inline-flex items-center gap-1 rounded-md font-medium",
        Mr(t),
        Lr(n),
        i
      ),
      ...m,
      children: [
        d,
        s && /* @__PURE__ */ a(
          "button",
          {
            type: "button",
            onClick: o,
            "aria-label": `Remove ${d}`,
            className: "rounded hover:bg-hover-overlay focus:outline-none p-0.5",
            children: /* @__PURE__ */ a(K, { className: Vr(n) })
          }
        )
      ]
    }
  );
});
Ge.displayName = "Tag";
const Rr = c((e, r) => {
  const {
    value: t = [],
    onChange: n,
    placeholder: o = "Add tag...",
    maxTags: s,
    allowDuplicates: i = !1,
    tagVariant: d = "default",
    tagSize: m = "md",
    disabled: f = !1,
    className: p,
    "aria-label": h = "Tag input",
    ...b
  } = e, [N, g] = A(""), x = (v) => {
    const y = v.trim();
    y && (!i && t.includes(y) || s && t.length >= s || (n?.([...t, y]), g("")));
  }, w = (v) => {
    const y = t.filter((S, C) => C !== v);
    n?.(y);
  }, T = (v) => {
    v.key === "Enter" && (v.preventDefault(), x(N)), v.key === "Backspace" && !N && t.length > 0 && w(t.length - 1);
  }, E = !s || t.length < s;
  return /* @__PURE__ */ u(
    "div",
    {
      ref: r,
      role: "group",
      "aria-label": h,
      className: l(
        "flex flex-wrap gap-2 rounded-md border border-border bg-background-secondary p-2",
        "focus-within:border-focus-ring focus-within:ring-2 focus-within:ring-focus-ring",
        f && "opacity-50 cursor-not-allowed",
        p
      ),
      ...b,
      children: [
        t.map((v, y) => /* @__PURE__ */ a(
          Ge,
          {
            variant: d,
            size: m,
            removable: !f,
            onRemove: () => w(y),
            children: v
          },
          `${v}-${y}`
        )),
        E && !f && /* @__PURE__ */ a(
          "input",
          {
            type: "text",
            value: N,
            onChange: (v) => g(v.target.value),
            onKeyDown: T,
            placeholder: t.length === 0 ? o : "",
            disabled: f,
            className: l(
              "flex-1 min-w-[120px] border-0 bg-transparent outline-none",
              "placeholder:text-foreground-muted",
              jr(m)
            )
          }
        )
      ]
    }
  );
});
Rr.displayName = "TagInput";
const _r = {
  default: "bg-foreground-muted/20 text-foreground",
  primary: "bg-button-primary/20 text-button-primary",
  secondary: "bg-foreground-accent/20 text-foreground-accent",
  success: "bg-green-500/20 text-green-400",
  warning: "bg-yellow-500/20 text-yellow-400"
};
function Mr(e) {
  return _r[e || "default"];
}
const zr = {
  sm: "px-2 py-0.5 text-xs",
  md: "px-2.5 py-1 text-sm",
  lg: "px-3 py-1.5 text-base"
};
function Lr(e) {
  return zr[e || "md"];
}
const Or = {
  sm: "h-3 w-3",
  md: "h-3.5 w-3.5",
  lg: "h-4 w-4"
};
function Vr(e) {
  return Or[e || "md"];
}
const Fr = {
  sm: "text-xs",
  md: "text-sm",
  lg: "text-base"
};
function jr(e) {
  return Fr[e || "md"];
}
const Hr = c((e, r) => {
  const { className: t, size: n, variant: o, ...s } = e;
  return /* @__PURE__ */ a(
    Ne.Root,
    {
      ref: r,
      className: l(
        "peer inline-flex shrink-0 cursor-pointer items-center rounded-full",
        "border-2 border-transparent transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring",
        "focus-visible:ring-offset-2 focus-visible:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=unchecked]:bg-border",
        Gr(n),
        Kr(o),
        t
      ),
      ...s,
      children: /* @__PURE__ */ a(
        Ne.Thumb,
        {
          className: l(
            "pointer-events-none block rounded-full shadow-lg",
            "ring-0 transition-transform",
            "bg-background data-[state=checked]:bg-foreground",
            "data-[state=checked]:translate-x-full",
            Zr(n)
          )
        }
      )
    }
  );
});
Hr.displayName = "Toggle";
const Br = {
  sm: "h-5 w-9",
  md: "h-6 w-11",
  lg: "h-7 w-14"
};
function Gr(e) {
  return Br[e || "md"];
}
const $r = {
  sm: "h-4 w-4 data-[state=checked]:translate-x-4",
  md: "h-5 w-5 data-[state=checked]:translate-x-5",
  lg: "h-6 w-6 data-[state=checked]:translate-x-7"
};
function Zr(e) {
  return $r[e || "md"];
}
const Ur = {
  default: "data-[state=checked]:bg-button-primary",
  success: "data-[state=checked]:bg-green-600",
  danger: "data-[state=checked]:bg-button-destructive"
};
function Kr(e) {
  return Ur[e || "default"];
}
const Wr = {
  default: "border border-border-secondary bg-background-secondary text-foreground",
  ghost: "border-transparent bg-transparent text-foreground"
}, Xr = {
  sm: "px-2 py-1.5 text-sm",
  md: "px-3 py-2 text-base",
  lg: "px-4 py-3 text-lg"
}, qr = c((e, r) => {
  const { variant: t = "default", textAreaSize: n = "md", className: o, ...s } = e;
  return /* @__PURE__ */ a(
    "textarea",
    {
      ref: r,
      className: l(
        "rounded-md transition-colors w-full min-h-[80px] resize-y",
        "focus:outline-none focus:ring-2 focus:ring-button-primary focus:ring-offset-1 focus:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "placeholder:text-foreground-muted",
        "hover:border-border-secondary",
        Wr[t],
        Xr[n],
        o
      ),
      ...s
    }
  );
});
qr.displayName = "TextArea";
const ve = {
  leading: "justify-start",
  center: "justify-center",
  trailing: "justify-end",
  between: "justify-between",
  default: "justify-center"
};
function Yr(e) {
  return e ? ve[e] : ve.default;
}
const we = {
  leading: "items-start",
  center: "items-center",
  trailing: "items-end",
  stretch: "items-stretch",
  default: "items-center"
};
function Jr(e) {
  return e ? we[e] : we.default;
}
const Se = {
  none: "gap-0",
  xs: "gap-1",
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-8",
  xl: "gap-12",
  "2xl": "gap-16",
  "3xl": "gap-24",
  default: "gap-2"
};
function $e(e) {
  return e ? typeof e == "number" ? `gap-${e}` : Se[e] : Se.default;
}
const Qr = {
  0: "min-w-0",
  1: "min-w-1",
  2: "min-w-2",
  4: "min-w-4",
  8: "min-w-8",
  12: "min-w-12",
  16: "min-w-16",
  20: "min-w-20",
  24: "min-w-24",
  32: "min-w-32"
};
function en(e) {
  return e ? Qr[e] ?? "" : "";
}
const Ce = {
  "top-leading": "items-start justify-start",
  top: "items-start justify-center",
  "top-trailing": "items-start justify-end",
  leading: "items-center justify-start",
  center: "items-center justify-center",
  trailing: "items-center justify-end",
  "bottom-leading": "items-end justify-start",
  bottom: "items-end justify-center",
  "bottom-trailing": "items-end justify-end"
};
function Ns(e) {
  return e ? Ce[e] : Ce.center;
}
const Z = c((e, r) => {
  const { alignment: t, spacing: n, className: o, children: s, ...i } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l("flex flex-col", Jr(t), $e(n), o),
      ...i,
      children: s
    }
  );
});
Z.displayName = "VStack";
const B = c((e, r) => {
  const { alignment: t, spacing: n, wrap: o, className: s, children: i, ...d } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l(
        "flex flex-row",
        Yr(t),
        $e(n),
        o && "flex-wrap",
        s
      ),
      ...d,
      children: i
    }
  );
});
B.displayName = "HStack";
const tn = c((e, r) => {
  const { minWidth: t, className: n, ...o } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l("flex-1", t && en(t), n),
      "aria-hidden": "true",
      ...o
    }
  );
});
tn.displayName = "Spacer";
const rn = c((e, r) => {
  const { orientation: t, variant: n, className: o, ...s } = e;
  return /* @__PURE__ */ a(
    "hr",
    {
      ref: r,
      className: l(
        "border-0",
        an(t),
        sn(n),
        o
      ),
      ...s
    }
  );
});
rn.displayName = "Divider";
const nn = {
  horizontal: "h-px w-full",
  vertical: "w-px h-full"
};
function an(e) {
  return nn[e || "horizontal"];
}
const on = {
  default: "bg-foreground",
  strong: "bg-gray-400",
  muted: "bg-foreground-muted/50"
};
function sn(e) {
  return on[e || "default"];
}
const ln = {
  width: "w-full",
  height: "h-full",
  all: "w-full h-full",
  fit: ""
}, dn = {
  default: "bg-background-secondary border border-border",
  outline: "bg-transparent border border-foreground-accent/50",
  ghost: "bg-transparent border-transparent",
  "dotted-outline": "bg-transparent border border-dashed border-foreground-accent/50"
}, cn = {
  none: "p-0",
  sm: "p-3",
  md: "p-4",
  lg: "p-6"
}, ce = c((e, r) => {
  const { variant: t = "default", padding: n = "md", expand: o, className: s, ...i } = e, d = o === !0 ? "all" : o, m = d ? ln[d] : "";
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l(
        "rounded-lg",
        dn[t],
        cn[n],
        m,
        s
      ),
      ...i
    }
  );
});
ce.displayName = "Card";
const mn = P.Root, ys = P.Trigger, un = {
  default: "max-w-[min(90vw,600px)]",
  // most modals
  lg: "max-w-[min(90vw,800px)]",
  // lists, search
  full: "max-w-[90vw]"
  // complex workflows
}, fn = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-lg",
  xl: "max-w-xl",
  "2xl": "max-w-2xl",
  full: "max-w-[calc(100vw-2rem)] sm:max-w-[calc(100vw-4rem)]"
}, pn = {
  auto: "",
  sm: "max-h-[50vh]",
  md: "max-h-[70vh]",
  lg: "max-h-[85vh]",
  full: "max-h-[calc(100vh-2rem)]"
}, Ze = c((e, r) => {
  const { className: t, children: n, showClose: o = !0, maxWidth: s, size: i, maxHeight: d, ...m } = e, f = i !== void 0 || d !== void 0;
  return /* @__PURE__ */ u(P.Portal, { children: [
    /* @__PURE__ */ a(P.Overlay, { className: "fixed inset-0 bg-black/80 backdrop-blur-sm animate-in fade-in z-50" }),
    /* @__PURE__ */ u(
      P.Content,
      {
        ref: r,
        className: l(
          "fixed left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]",
          "bg-sonify-dark border border-sonify-gray/30",
          "rounded-xl shadow-2xl",
          "z-50",
          "flex flex-col",
          "overflow-hidden",
          "animate-in zoom-in-95",
          // New responsive defaults OR legacy mode
          f ? ["w-full", fn[i ?? "md"], pn[d ?? "md"]] : [
            "w-fit min-w-[320px]",
            "max-h-[calc(100vh-4rem)]",
            un[s ?? "default"]
          ],
          t
        ),
        ...m,
        children: [
          n,
          o && /* @__PURE__ */ a(P.Close, { className: "absolute right-4 top-4 rounded-sm text-sonify-muted hover:text-sonify-white transition-colors z-10", children: /* @__PURE__ */ a(K, { className: "h-4 w-4" }) })
        ]
      }
    )
  ] });
});
Ze.displayName = "DialogContent";
const ee = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a("div", { ref: r, className: l("flex-shrink-0 px-6 pt-6 pb-4 space-y-2", t), ...n });
});
ee.displayName = "DialogHeader";
const re = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l("flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-6 py-2", t),
      ...n
    }
  );
});
re.displayName = "DialogBody";
const U = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      P.Title,
      {
        ref: r,
        className: l("text-lg font-semibold text-sonify-white", t),
        ...n
      }
    );
  }
);
U.displayName = "DialogTitle";
const ne = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    P.Description,
    {
      ref: r,
      className: l("text-sm text-sonify-muted", t),
      ...n
    }
  );
});
ne.displayName = "DialogDescription";
const me = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l("flex-shrink-0 px-6 pb-6 pt-4 flex justify-end gap-3", t),
      ...n
    }
  );
});
me.displayName = "DialogFooter";
const gn = c((e, r) => {
  const {
    label: t,
    required: n,
    hint: o,
    error: s,
    disabled: i,
    gridSpan: d = "half",
    inline: m = !1,
    children: f,
    className: p,
    ...h
  } = e;
  return /* @__PURE__ */ u(
    "div",
    {
      ref: r,
      className: l(
        // Base card styles
        "rounded-lg border p-3",
        // Grid span
        d === "full" && "md:col-span-2",
        // Default state - inset/recessed surface within parent card
        "bg-surface-inset border-border/60",
        // Hover state (when not disabled) - lighten slightly to indicate interactivity
        !i && "transition-colors hover:border-border hover:bg-background-secondary/50",
        // Error state
        s && "border-red-500/50 hover:border-red-500/70",
        // Disabled state
        i && "opacity-60 cursor-not-allowed",
        p
      ),
      ...h,
      children: [
        m ? (
          // Inline layout: label and content on same row
          /* @__PURE__ */ u("div", { className: "flex items-center justify-between gap-3", children: [
            /* @__PURE__ */ u("label", { className: "text-sm font-medium text-foreground", children: [
              t,
              n && /* @__PURE__ */ a("span", { className: "text-red-500 ml-0.5", children: "*" })
            ] }),
            f
          ] })
        ) : (
          // Stacked layout: label above content
          /* @__PURE__ */ u("div", { className: "space-y-2", children: [
            /* @__PURE__ */ u("label", { className: "block text-sm font-medium text-foreground", children: [
              t,
              n && /* @__PURE__ */ a("span", { className: "text-red-500 ml-0.5", children: "*" })
            ] }),
            f
          ] })
        ),
        o && !s && /* @__PURE__ */ a("p", { className: l("text-xs text-foreground-muted", m ? "mt-2" : "mt-1.5"), children: o }),
        s && /* @__PURE__ */ a("p", { className: l("text-xs text-red-500", m ? "mt-2" : "mt-1.5"), children: s })
      ]
    }
  );
});
gn.displayName = "FieldCard";
const vs = P.Root, ws = P.Trigger, hn = {
  sm: "w-[300px]",
  default: "w-[350px] sm:w-[400px]",
  lg: "w-[400px] sm:w-[450px]",
  xl: "w-[450px] sm:w-[500px]",
  full: "w-[calc(100vw-2rem)] sm:w-[calc(100vw-4rem)]"
}, bn = {
  top: "items-start justify-center",
  right: "items-center justify-end",
  bottom: "items-end justify-center",
  left: "items-center justify-start"
}, xn = {
  top: "animate-in slide-in-from-top duration-300",
  right: "animate-in slide-in-from-right duration-300",
  bottom: "animate-in slide-in-from-bottom duration-300",
  left: "animate-in slide-in-from-left duration-300"
}, Nn = c((e, r) => {
  const {
    className: t,
    children: n,
    side: o = "right",
    size: s = "default",
    showClose: i = !0,
    ...d
  } = e;
  return /* @__PURE__ */ u(P.Portal, { children: [
    /* @__PURE__ */ a(P.Overlay, { className: "fixed inset-0 bg-black/50 backdrop-blur-sm z-50 animate-in fade-in" }),
    /* @__PURE__ */ u(
      P.Content,
      {
        ref: r,
        className: l(
          "fixed z-50 flex flex-col bg-sonify-dark border border-sonify-gray/30 shadow-2xl",
          "max-h-[calc(100vh-2rem)] overflow-hidden",
          bn[o],
          xn[o],
          hn[s],
          o === "top" && "top-0 rounded-b-xl",
          o === "right" && "h-full rounded-l-xl",
          o === "bottom" && "bottom-0 rounded-t-xl",
          o === "left" && "h-full rounded-r-xl",
          t
        ),
        ...d,
        children: [
          n,
          i && /* @__PURE__ */ a(P.Close, { className: "absolute right-4 top-4 rounded-sm text-sonify-muted hover:text-sonify-white transition-colors z-10", children: /* @__PURE__ */ a(K, { className: "h-4 w-4" }) })
        ]
      }
    )
  ] });
});
Nn.displayName = "SheetContent";
const yn = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l("flex-shrink-0 px-4 py-3 border-b border-border", t),
      ...n
    }
  );
});
yn.displayName = "SheetHeader";
const vn = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      P.Title,
      {
        ref: r,
        className: l("text-lg font-semibold text-sonify-white", t),
        ...n
      }
    );
  }
);
vn.displayName = "SheetTitle";
const wn = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    P.Description,
    {
      ref: r,
      className: l("text-sm text-sonify-muted", t),
      ...n
    }
  );
});
wn.displayName = "SheetDescription";
const Sn = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l(
        "flex-shrink-0 px-4 py-3 flex justify-end gap-3 border-t border-border",
        t
      ),
      ...n
    }
  );
});
Sn.displayName = "SheetFooter";
const Cn = {
  "top-right": "top-4 right-4 flex-col",
  "top-left": "top-4 left-4 flex-col",
  "bottom-right": "bottom-4 right-4 flex-col-reverse",
  "bottom-left": "bottom-4 left-4 flex-col-reverse",
  "bottom-center": "bottom-4 left-1/2 -translate-x-1/2 flex-col-reverse"
}, Ss = G.Provider, Tn = c((e, r) => {
  const { className: t, position: n = "top-right", ...o } = e;
  return /* @__PURE__ */ a(
    G.Viewport,
    {
      ref: r,
      className: l(
        "fixed z-[100] flex gap-3 max-h-screen w-full p-4 md:max-w-[360px]",
        Cn[n],
        t
      ),
      ...o
    }
  );
});
Tn.displayName = "ToastViewport";
const An = c((e, r) => {
  const { className: t, variant: n, ...o } = e;
  return /* @__PURE__ */ a(
    G.Root,
    {
      ref: r,
      className: l(
        "group pointer-events-auto relative",
        "flex flex-col w-full gap-1.5",
        "mx-2 md:mx-0",
        "overflow-hidden rounded-lg border p-3 shadow-xl transition-all",
        "data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)]",
        "data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
        "data-[swipe=move]:transition-none",
        // Animations using Radix state attributes
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=open]:duration-300 data-[state=closed]:duration-200",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "data-[state=open]:slide-in-from-bottom-6 md:data-[state=open]:slide-in-from-right-6",
        "data-[state=closed]:slide-out-to-bottom-3 md:data-[state=closed]:slide-out-to-right-6",
        Rn(n),
        t
      ),
      ...o
    }
  );
});
An.displayName = "Toast";
const In = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      G.Action,
      {
        ref: r,
        className: l(
          "bg-sonify-cyan-light text-sonify-black border-transparent",
          "h-7 px-3 py-1.5",
          "inline-flex shrink-0 items-center justify-center rounded-md border self-end",
          "text-xs font-medium ring-offset-surface-elevated transition-colors",
          "hover:bg-sonify-cyan focus:outline-none focus:ring-2 focus:ring-sonify-cyan-light",
          "focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
          t
        ),
        ...n
      }
    );
  }
);
In.displayName = "ToastAction";
const kn = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      G.Close,
      {
        ref: r,
        className: l(
          "absolute right-2 top-2 rounded-md p-1 transition-opacity",
          "opacity-100 md:opacity-0",
          "text-foreground-muted hover:text-foreground",
          "hover:opacity-100 focus:opacity-100 focus:outline-none group-hover:opacity-100",
          t
        ),
        "toast-close": "",
        ...n,
        children: /* @__PURE__ */ a(K, { className: "h-4 w-4" })
      }
    );
  }
);
kn.displayName = "ToastClose";
const Pn = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(G.Title, { ref: r, className: l("text-sm font-semibold", t), ...n });
  }
);
Pn.displayName = "ToastTitle";
const En = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(G.Description, { ref: r, className: l("text-xs", t), ...n });
});
En.displayName = "ToastDescription";
const Dn = {
  default: [
    "bg-surface-elevated",
    "border-l-4 border-l-foreground-accent",
    "border-y border-r border-border/50",
    "text-foreground",
    "shadow-lg"
  ].join(" "),
  success: [
    "bg-surface-elevated",
    "border-l-4 border-l-green-500",
    "border-y border-r border-border/50",
    "text-foreground",
    "shadow-lg"
  ].join(" "),
  warning: [
    "bg-surface-elevated",
    "border-l-4 border-l-sonify-yellow",
    "border-y border-r border-border/50",
    "text-foreground",
    "shadow-lg"
  ].join(" "),
  error: [
    "bg-surface-elevated",
    "border-l-4 border-l-sonify-red",
    "border-y border-r border-border/50",
    "text-foreground",
    "shadow-lg"
  ].join(" "),
  info: [
    "bg-surface-elevated",
    "border-l-4 border-l-sonify-accent",
    "border-y border-r border-border/50",
    "text-foreground",
    "shadow-lg"
  ].join(" ")
};
function Rn(e) {
  return Dn[e || "default"];
}
const _n = {
  "3xs": "text-[8px] leading-[10px]",
  "2xs": "text-[10px] leading-[12px]",
  xs: "text-xs",
  sm: "text-sm",
  base: "text-base",
  lg: "text-lg",
  xl: "text-xl",
  "2xl": "text-2xl",
  "3xl": "text-3xl",
  "4xl": "text-4xl",
  "5xl": "text-5xl",
  "6xl": "text-6xl",
  "7xl": "text-7xl",
  "8xl": "text-8xl",
  "9xl": "text-9xl"
}, Mn = {
  normal: "font-normal",
  medium: "font-medium",
  semibold: "font-semibold",
  bold: "font-bold"
}, D = {
  default: "text-foreground",
  muted: "text-foreground-muted",
  accent: "text-foreground-accent",
  heading: "text-foreground-heading",
  error: "text-red-600",
  success: "text-green-600"
}, R = {
  default: "",
  normal: "whitespace-normal",
  nowrap: "whitespace-nowrap",
  pre: "whitespace-pre",
  preLine: "whitespace-pre-line",
  preWrap: "whitespace-pre-wrap"
}, ie = c((e, r) => {
  const {
    size: t = "base",
    weight: n = "normal",
    color: o = "default",
    wrap: s = "default",
    as: i = "p",
    className: d,
    ...m
  } = e;
  return /* @__PURE__ */ a(
    i,
    {
      ref: r,
      className: l(
        _n[t],
        Mn[n],
        D[o],
        R[s],
        d
      ),
      ...m
    }
  );
});
ie.displayName = "Text";
const zn = {
  xs: "text-sm",
  sm: "text-base",
  base: "text-lg",
  lg: "text-xl",
  xl: "text-2xl",
  "2xl": "text-3xl"
}, Ln = {
  default: "text-foreground",
  muted: "text-foreground-muted",
  accent: "text-foreground-accent",
  heading: "text-foreground-heading"
}, On = c((e, r) => {
  const { as: t = "h2", size: n = "lg", color: o = "default", className: s, ...i } = e;
  return /* @__PURE__ */ a(
    t,
    {
      ref: r,
      className: l("font-semibold", zn[n], Ln[o], s),
      ...i
    }
  );
});
On.displayName = "Heading";
const Vn = c(
  ({ color: e = "default", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "h1",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop → 4K
        "text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Vn.displayName = "Display";
const Fn = c(
  ({ color: e = "heading", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "h1",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop → 4K
        "text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-semibold tracking-tight",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Fn.displayName = "Heading1";
const jn = c(
  ({ color: e = "heading", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "h2",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop → 4K
        "text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-semibold tracking-tight",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
jn.displayName = "Heading2";
const Hn = c(
  ({ color: e = "heading", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "h3",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop → 4K
        "text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-semibold",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Hn.displayName = "Heading3";
const Bn = c(
  ({ color: e = "heading", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "h4",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop → 4K
        "text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl font-semibold",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Bn.displayName = "Heading4";
const Gn = c(
  ({ color: e = "heading", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "h5",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop → 4K
        "text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl font-semibold",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Gn.displayName = "Heading5";
const $n = c(
  ({ color: e = "default", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "p",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop
        "text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
$n.displayName = "BodyLarge";
const Zn = c(
  ({ color: e = "default", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "p",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop
        "text-sm sm:text-base md:text-lg lg:text-xl leading-normal",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Zn.displayName = "Body";
const Un = c(
  ({ color: e = "default", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "p",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop
        "text-xs sm:text-sm md:text-base lg:text-lg leading-normal",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Un.displayName = "BodySmall";
const Kn = c(
  ({ color: e = "muted", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "span",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop → desktop
        "text-xs sm:text-sm md:text-base lg:text-lg",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Kn.displayName = "Caption";
const Wn = c(
  ({ color: e = "muted", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "span",
    {
      ref: o,
      className: l(
        // mobile → tablet → laptop
        "text-xs sm:text-sm md:text-base",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Wn.displayName = "CaptionSmall";
const Xn = c(
  ({ color: e = "muted", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "span",
    {
      ref: o,
      className: l(
        // Stays small across breakpoints for labels/tags
        "text-xs sm:text-sm font-semibold uppercase tracking-wider",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
Xn.displayName = "Overline";
const qn = c(
  ({ color: e = "default", wrap: r = "default", className: t, ...n }, o) => /* @__PURE__ */ a(
    "code",
    {
      ref: o,
      className: l(
        "text-sm font-mono bg-surface-secondary px-1.5 py-0.5 rounded",
        D[e],
        R[r],
        t
      ),
      ...n
    }
  )
);
qn.displayName = "Code";
const Q = {
  default: {
    root: "",
    item: "border-b border-border px-[var(--accordion-inset,0px)]",
    trigger: "flex w-full items-center justify-between py-5 text-foreground-accent text-lg data-[state=open]:text-foreground",
    chevron: "h-5 w-5 shrink-0 transition-transform duration-200 text-foreground-accent [[data-state=open]_&]:text-foreground",
    content: "overflow-hidden accordion-content"
  }
}, Te = {
  sm: { text: "text-sm", chevron: "h-4 w-4" },
  md: { text: "text-base", chevron: "h-5 w-5" },
  lg: { text: "text-lg", chevron: "h-5 w-5" },
  xl: { text: "text-xl", chevron: "h-6 w-6" }
}, Ue = Ie({ variant: "default", size: "md" }), ue = () => Qe(Ue), Yn = c(
  ({ type: e, size: r = "md", variant: t = "default", className: n, children: o, ...s }, i) => /* @__PURE__ */ a(Ue.Provider, { value: { variant: t, size: r }, children: /* @__PURE__ */ a(
    Y.Root,
    {
      ...s,
      ref: i,
      type: e,
      collapsible: !0,
      className: l(Q[t].root, n),
      children: o
    }
  ) })
);
Yn.displayName = "Accordion";
const Jn = c(
  ({ className: e, ...r }, t) => {
    const { variant: n } = ue();
    return /* @__PURE__ */ a(
      Y.Item,
      {
        ref: t,
        className: l(Q[n].item, "", e),
        ...r
      }
    );
  }
);
Jn.displayName = "AccordionItem";
const Qn = c(
  ({ className: e, children: r, ...t }, n) => {
    const { variant: o, size: s } = ue();
    return /* @__PURE__ */ a(Y.Header, { className: "flex", children: /* @__PURE__ */ u(
      Y.Trigger,
      {
        ref: n,
        className: l(
          Q[o].trigger,
          Te[s].text,
          "relative data-[state=open]:after:absolute data-[state=open]:after:bottom-0 data-[state=open]:after:left-[calc(-1*var(--accordion-inset,0px))] data-[state=open]:after:right-[calc(-1*var(--accordion-inset,0px))] data-[state=open]:after:h-px data-[state=open]:after:bg-border",
          e
        ),
        ...t,
        children: [
          r,
          /* @__PURE__ */ a(
            De,
            {
              className: l(
                "[[data-state=open]_&]:rotate-90",
                Q[o].chevron,
                Te[s].chevron
              )
            }
          )
        ]
      }
    ) });
  }
);
Qn.displayName = "AccordionTrigger";
const ea = c(
  ({ className: e, children: r, ...t }, n) => {
    const { variant: o } = ue();
    return /* @__PURE__ */ a(
      Y.Content,
      {
        ref: n,
        className: l(Q[o].content, "py-4", e),
        ...t,
        children: r
      }
    );
  }
);
ea.displayName = "AccordionContent";
function ta(e) {
  let r = 0;
  for (let d = 0; d < e.length; d++)
    r = (r << 5) - r + e.charCodeAt(d), r |= 0;
  const t = Math.abs(r % 360), n = (t + 40 + (r >> 8) % 80) % 360, o = 45 + Math.abs((r >> 16) % 90), s = 65, i = 45;
  return `linear-gradient(${o}deg, hsl(${t}, ${s}%, ${i}%), hsl(${n}, ${s}%, ${i}%))`;
}
const ra = c((e, r) => {
  const { src: t, alt: n, fallback: o, hashKey: s, size: i, variant: d, className: m, ...f } = e, p = n ?? (o ? `Avatar for ${o}` : "User avatar");
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      role: "img",
      "aria-label": p,
      className: l(
        "relative inline-flex shrink-0 overflow-hidden aspect-square",
        "bg-background-secondary",
        d && sa(d),
        i && ia(i),
        m
      ),
      ...f,
      children: t ? /* @__PURE__ */ a(na, { src: t, alt: p }) : /* @__PURE__ */ a(aa, { hashKey: s, children: o })
    }
  );
});
ra.displayName = "Avatar";
const na = ({ src: e, alt: r }) => /* @__PURE__ */ a(
  "img",
  {
    src: e,
    alt: r,
    className: "aspect-square h-full w-full object-cover",
    decoding: "async",
    loading: "lazy",
    onError: (t) => {
      t.target.style.display = "none";
    }
  }
), aa = ({ children: e, hashKey: r }) => {
  const t = e?.slice(0, 2).toUpperCase() || "?", n = r ? { background: ta(r) } : void 0;
  return /* @__PURE__ */ a(
    "span",
    {
      className: l(
        "flex h-full w-full items-center justify-center font-semibold",
        r ? "text-white" : "bg-surface-elevated text-foreground-muted"
      ),
      style: n,
      children: t
    }
  );
}, oa = {
  circle: "rounded-full",
  square: "rounded-md"
};
function sa(e) {
  return oa[e || "circle"];
}
const la = {
  xs: "h-6 w-6 text-xs",
  sm: "h-8 w-8 text-sm",
  md: "h-10 w-10 text-base",
  lg: "h-12 w-12 text-lg",
  xl: "h-16 w-16 text-xl"
};
function ia(e) {
  return la[e || "md"];
}
const da = c((e, r) => {
  const { variant: t, size: n, className: o, children: s, ...i } = e;
  return /* @__PURE__ */ a(
    "span",
    {
      ref: r,
      className: l(
        "inline-flex items-center font-medium rounded-full",
        ma(t),
        fa(n),
        o
      ),
      ...i,
      children: s
    }
  );
});
da.displayName = "Badge";
const ca = {
  default: "bg-foreground-muted/20 text-foreground",
  primary: "bg-button-primary/20 text-button-primary",
  secondary: "bg-foreground-accent/20 text-foreground-accent",
  outline: "bg-transparent border border-border text-foreground",
  success: "bg-success-background text-success-text",
  warning: "bg-warning-background text-warning-text",
  danger: "bg-error-background text-error-text"
};
function ma(e) {
  return ca[e || "default"];
}
const ua = {
  sm: "px-2 py-0.5 text-xs",
  md: "px-2.5 py-0.5 text-sm",
  lg: "px-3 py-1 text-base"
};
function fa(e) {
  return ua[e || "md"];
}
function Cs({ variant: e = "full", className: r }) {
  const t = e === "compact";
  return /* @__PURE__ */ u(
    "div",
    {
      className: l(
        "flex flex-col items-center justify-center h-full w-full bg-background",
        r
      ),
      children: [
        /* @__PURE__ */ a(
          "div",
          {
            className: l(
              "rounded-full flex items-center justify-center",
              t ? "h-12 w-12" : "h-20 w-20",
              "animate-[pulse-glow_2s_ease-in-out_infinite]"
            ),
            children: /* @__PURE__ */ a(pa, { className: l("text-logo-primary", t ? "h-8 w-8" : "h-14 w-14") })
          }
        ),
        !t && /* @__PURE__ */ a("div", { className: "flex items-end gap-1 mt-6 h-8", children: [0, 1, 2, 3, 4].map((n) => /* @__PURE__ */ a(
          "div",
          {
            className: "w-1 bg-logo-primary rounded-full origin-bottom animate-[waveform-bar_1.2s_ease-in-out_infinite]",
            style: {
              height: "100%",
              animationDelay: `${n * 0.15}s`
            }
          },
          n
        )) })
      ]
    }
  );
}
function pa({ className: e }) {
  return /* @__PURE__ */ a("svg", { viewBox: "0 0 1355 1366", xmlns: "http://www.w3.org/2000/svg", className: e, children: /* @__PURE__ */ a(
    "path",
    {
      d: "M677.192 0C303.2 0 0 305.645 0 682.653C0 1059.66 303.2 1365.31 677.192 1365.31C1051.18 1365.31 1354.38 1059.66 1354.38 682.653C1354.38 305.645 1051.18 0 677.192 0ZM900.259 918.865C900.259 1001.91 833.407 1069.3 751.023 1069.3H316.256C233.872 1069.3 167.019 1001.91 167.019 918.865V890.841C167.019 807.793 233.872 740.401 316.256 740.401H751.023C833.407 740.401 900.259 807.793 900.259 890.841V918.865ZM1031.26 624.905H596.496C514.112 624.905 447.26 557.513 447.26 474.465V446.442C447.26 363.393 514.112 296.002 596.496 296.002H1031.26C1113.65 296.002 1180.5 363.393 1180.5 446.442V474.465C1180.5 557.513 1113.65 624.905 1031.26 624.905Z",
      fill: "currentColor"
    }
  ) });
}
const ga = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ a("table", { ref: r, className: l("w-full caption-bottom text-sm", t), ...n }) });
});
ga.displayName = "Table";
const ha = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      "thead",
      {
        ref: r,
        className: l("border-b border-border-secondary text-foreground", t),
        ...n
      }
    );
  }
);
ha.displayName = "TableHeader";
const ba = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a("tbody", { ref: r, className: l("[&_tr:last-child]:border-0", t), ...n });
  }
);
ba.displayName = "TableBody";
const xa = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      "tfoot",
      {
        ref: r,
        className: l("border-t border-border-secondary font-medium", t),
        ...n
      }
    );
  }
);
xa.displayName = "TableFooter";
const Na = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    "tr",
    {
      ref: r,
      className: l(
        "group",
        // Hover state only if clickable and not disabled
        e.onClick && !e.disabled && "cursor-pointer",
        t
      ),
      onClick: e.disabled ? void 0 : e.onClick,
      onDoubleClick: e.disabled ? void 0 : e.onDoubleClick,
      "data-state": e.selected ? "selected" : void 0,
      "aria-selected": e.selected,
      "aria-disabled": e.disabled,
      ...n
    }
  );
});
Na.displayName = "TableRow";
const ya = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    "th",
    {
      ref: r,
      className: l(
        "h-12 px-4 text-left align-middle font-medium text-foreground-muted",
        "[&:has([role=checkbox])]:pr-0",
        t
      ),
      ...n
    }
  );
});
ya.displayName = "TableHead";
const fe = c((e, r) => {
  const { className: t, ...n } = e, o = (s) => {
    e.stopPropagation && s.stopPropagation(), e.onClick?.(s);
  };
  return /* @__PURE__ */ a(
    "td",
    {
      ref: r,
      className: l(
        "p-4 align-middle",
        "[&:has([role=checkbox])]:pr-0",
        "group-hover:bg-hover-overlay",
        "group-data-[state=selected]:bg-active-overlay",
        "transition-colors",
        t
      ),
      onClick: o,
      ...n
    }
  );
});
fe.displayName = "TableCell";
const va = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(
      "caption",
      {
        ref: r,
        className: l("mt-4 text-sm text-foreground-muted", t),
        ...n
      }
    );
  }
);
va.displayName = "TableCaption";
const wa = c(
  ({ listeners: e, attributes: r, disabled: t, className: n, ...o }, s) => /* @__PURE__ */ a(fe, { ref: s, stopPropagation: !0, className: n ?? "w-10", ...o, children: /* @__PURE__ */ a(
    "button",
    {
      type: "button",
      ...e,
      ...r,
      disabled: t,
      "aria-label": "Drag to reorder",
      className: l(
        "p-1 rounded hover:bg-hover-overlay cursor-grab active:cursor-grabbing",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring",
        t && "cursor-not-allowed opacity-50"
      ),
      children: /* @__PURE__ */ a(lt, { className: "h-4 w-4 text-foreground-muted" })
    }
  ) })
);
wa.displayName = "DragHandleCell";
const W = c((e, r) => {
  const { icon: t, title: n, description: o, action: s, size: i, className: d, children: m, ...f } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      "data-testid": "empty-state",
      className: l(
        "flex flex-col items-center justify-center text-center",
        Ca(i),
        d
      ),
      ...f,
      children: m || /* @__PURE__ */ u(X, { children: [
        t && /* @__PURE__ */ a("div", { className: l("text-gray-400", Aa(i)), children: t }),
        n && /* @__PURE__ */ a("h3", { className: l("font-semibold text-gray-900", t && "mt-4", ka(i)), children: n }),
        o && /* @__PURE__ */ a("p", { className: l("text-gray-600", n && "mt-2", Ea(i)), children: o }),
        s && /* @__PURE__ */ a("div", { className: l((n || o) && "mt-6"), children: s })
      ] })
    }
  );
});
W.displayName = "EmptyState";
const Sa = {
  sm: "py-8",
  md: "py-12",
  lg: "py-16"
};
function Ca(e) {
  return Sa[e || "md"];
}
const Ta = {
  sm: "[&>svg]:h-8 [&>svg]:w-8",
  md: "[&>svg]:h-12 [&>svg]:w-12",
  lg: "[&>svg]:h-16 [&>svg]:w-16"
};
function Aa(e) {
  return Ta[e || "md"];
}
const Ia = {
  sm: "text-base",
  md: "text-lg",
  lg: "text-xl"
};
function ka(e) {
  return Ia[e || "md"];
}
const Pa = {
  sm: "text-sm max-w-sm",
  md: "text-base max-w-md",
  lg: "text-lg max-w-lg"
};
function Ea(e) {
  return Pa[e || "md"];
}
const Ts = {
  NoTracks: () => /* @__PURE__ */ a(
    W,
    {
      icon: /* @__PURE__ */ a(ht, {}),
      title: "No tracks found",
      description: "Try adjusting your filters or search terms"
    }
  ),
  NoResults: () => /* @__PURE__ */ a(
    W,
    {
      icon: /* @__PURE__ */ a(Re, {}),
      title: "No results",
      description: "We couldn't find what you're looking for"
    }
  ),
  UploadFirst: ({ onUpload: e }) => /* @__PURE__ */ a(
    W,
    {
      icon: /* @__PURE__ */ a(dt, {}),
      title: "Upload your first track",
      description: "Start building your music library by uploading your tracks",
      action: /* @__PURE__ */ a(z, { onClick: e, variant: "primary", children: "Upload Track" })
    }
  ),
  ComingSoon: () => /* @__PURE__ */ a(
    W,
    {
      icon: /* @__PURE__ */ a(it, {}),
      title: "Coming soon",
      description: "This feature is under development and will be available soon"
    }
  )
}, Da = {
  xs: "w-3 h-3",
  // pairs with CaptionSmall
  sm: "w-4 h-4",
  // pairs with Caption, BodySmall
  md: "w-5 h-5",
  // pairs with Body
  lg: "w-6 h-6",
  // pairs with Heading4
  xl: "w-8 h-8",
  // pairs with Heading3
  "2xl": "w-10 h-10",
  // pairs with Heading2
  "3xl": "w-12 h-12",
  // pairs with Heading1
  "4xl": "w-16 h-16"
  // pairs with Display
}, Ra = {
  xs: "w-3 h-3 sm:w-4 sm:h-4",
  sm: "w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6",
  md: "w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7",
  lg: "w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8",
  xl: "w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10",
  "2xl": "w-10 h-10 sm:w-11 sm:h-11 md:w-12 md:h-12",
  "3xl": "w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16",
  "4xl": "w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24"
}, Ke = c(
  ({ children: e, size: r = "md", responsive: t = !0, className: n, ...o }, s) => {
    const i = t ? Ra[r] : Da[r], d = et(e, {
      className: l(i, e.props.className)
    });
    return /* @__PURE__ */ a(
      "span",
      {
        ref: s,
        className: l("inline-flex items-center justify-center shrink-0", n),
        ...o,
        children: d
      }
    );
  }
);
Ke.displayName = "InlineIcon";
const _a = c((e, r) => {
  const {
    label: t,
    required: n,
    error: o,
    direction: s = "vertical",
    variant: i = "default",
    className: d,
    children: m,
    ...f
  } = e;
  return i === "inline-toggle" ? /* @__PURE__ */ u("div", { ref: r, className: l("flex items-center gap-3", d), ...f, children: [
    /* @__PURE__ */ u("span", { className: l("text-sm text-foreground-muted", o && "text-error"), children: [
      t,
      n && /* @__PURE__ */ a("span", { className: "ml-1 text-error", children: "*" })
    ] }),
    m
  ] }) : /* @__PURE__ */ u(
    "div",
    {
      ref: r,
      className: l(
        s === "horizontal" ? "flex items-center gap-3" : "space-y-2",
        d
      ),
      ...f,
      children: [
        /* @__PURE__ */ u("span", { className: l("text-sm font-medium text-foreground-muted", o && "text-error"), children: [
          t,
          n && /* @__PURE__ */ a("span", { className: "ml-1 text-error", children: "*" })
        ] }),
        /* @__PURE__ */ a("div", { className: "flex-1", children: m })
      ]
    }
  );
});
_a.displayName = "LabelledContent";
const As = I.Root, Is = I.Trigger, ks = I.Anchor, Ma = c((e, r) => {
  const { className: t, align: n = "center", sideOffset: o = 4, ...s } = e;
  return /* @__PURE__ */ a(I.Portal, { children: /* @__PURE__ */ a(
    I.Content,
    {
      ref: r,
      align: n,
      sideOffset: o,
      className: l(
        "z-50 w-72 rounded-md border border-border bg-surface-elevated p-4",
        "shadow-md outline-none",
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=top]:slide-in-from-bottom-2",
        t
      ),
      ...s
    }
  ) });
});
Ma.displayName = "PopoverContent";
const za = c(
  (e, r) => {
    const { className: t, ...n } = e;
    return /* @__PURE__ */ a(I.Arrow, { ref: r, className: l("fill-surface-elevated", t), ...n });
  }
);
za.displayName = "PopoverArrow";
const Ps = I.Close, La = c(
  ({ className: e, ...r }, t) => /* @__PURE__ */ a(
    "div",
    {
      ref: t,
      className: l("px-2 py-1.5 text-sm font-medium text-foreground-accent", e),
      ...r
    }
  )
);
La.displayName = "PopoverLabel";
const Oa = c(
  ({ className: e, ...r }, t) => /* @__PURE__ */ a("div", { ref: t, className: l("-mx-1 my-1 h-px bg-border", e), ...r })
);
Oa.displayName = "PopoverSeparator";
const Va = c((e, r) => {
  const { value: t = 0, max: n = 100, variant: o, className: s, ...i } = e, d = Math.min(Math.max(t / n * 100, 0), 100);
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": n,
      "aria-valuenow": t,
      className: l(
        "relative w-full h-1 overflow-hidden rounded-full bg-foreground-muted/50",
        s
      ),
      ...i,
      children: /* @__PURE__ */ a(
        "div",
        {
          className: l(
            "h-full transition-all duration-300 ease-in-out",
            ja(o)
          ),
          style: { width: `${d}%` }
        }
      )
    }
  );
});
Va.displayName = "Progress";
const Fa = {
  default: "bg-foreground-accent",
  success: "bg-green-500",
  warning: "bg-yellow-500",
  error: "bg-red-500",
  info: "bg-blue-500"
};
function ja(e) {
  return Fa[e || "default"];
}
const Ha = c(
  ({ checked: e, indeterminate: r, onCheckedChange: t, disabled: n, className: o, ...s }, i) => /* @__PURE__ */ a(fe, { ref: i, stopPropagation: !0, className: o ?? "w-12", ...s, children: /* @__PURE__ */ a(
    Ve,
    {
      checked: r ? "indeterminate" : e,
      onCheckedChange: (d) => {
        typeof d == "boolean" && t?.(d);
      },
      disabled: n,
      "aria-label": e ? "Deselect row" : "Select row"
    }
  ) })
);
Ha.displayName = "SelectionCell";
const F = c((e, r) => {
  const { variant: t, animation: n = "pulse", className: o, ...s } = e, i = n === "shimmer";
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l(
        "rounded-md bg-foreground-muted/10",
        Ga(t),
        Za(n),
        i && "bg-gradient-to-r from-foreground-muted/10 via-foreground-muted/20 to-foreground-muted/10 bg-[length:200%_100%]",
        o
      ),
      ...s
    }
  );
});
F.displayName = "Skeleton";
const Ba = {
  default: "",
  text: "h-4 w-full",
  title: "h-8 w-3/4",
  avatar: "h-10 w-10 rounded-full",
  button: "h-10 w-24",
  card: "h-32 w-full",
  thumbnail: "h-20 w-20 rounded-md",
  waveform: "h-24 w-full"
};
function Ga(e) {
  return Ba[e || "default"];
}
const $a = {
  pulse: "animate-pulse",
  shimmer: "animate-[shimmer_1.5s_ease-in-out_infinite]",
  none: ""
};
function Za(e) {
  return $a[e || "pulse"];
}
const Es = ({ lines: e = 3 }) => /* @__PURE__ */ a("div", { className: "space-y-2", children: Array.from({ length: e }).map((r, t) => /* @__PURE__ */ a(F, { variant: "text", className: t === e - 1 ? "w-4/5" : "" }, t)) }), Ds = () => /* @__PURE__ */ u("div", { className: "flex items-center space-x-4 p-4", children: [
  /* @__PURE__ */ a(F, { variant: "thumbnail" }),
  /* @__PURE__ */ u("div", { className: "flex-1 space-y-2", children: [
    /* @__PURE__ */ a(F, { className: "h-4 w-1/3" }),
    /* @__PURE__ */ a(F, { className: "h-3 w-1/4" })
  ] }),
  /* @__PURE__ */ a(F, { className: "h-8 w-20" })
] }), Rs = ({ bars: e = 40, className: r }) => /* @__PURE__ */ a("div", { className: l("flex items-end gap-0.5 h-16", r), children: Array.from({ length: e }).map((t, n) => /* @__PURE__ */ a(
  "div",
  {
    className: "flex-1 bg-foreground-muted/10 rounded-sm animate-pulse",
    style: {
      height: `${30 + Math.sin(n * 0.5) * 30 + Math.random() * 40}%`,
      animationDelay: `${n * 30}ms`
    }
  },
  n
)) }), _s = ({ size: e = "md", className: r }) => /* @__PURE__ */ a(
  "div",
  {
    className: l(
      "bg-foreground-muted/10 rounded-md flex items-center justify-center animate-pulse",
      {
        sm: "h-12 w-12",
        md: "h-20 w-20",
        lg: "h-32 w-32"
      }[e],
      r
    ),
    children: /* @__PURE__ */ a(Ua, { className: "w-1/3 h-1/3 text-foreground-muted/20" })
  }
);
function Ua({ className: e }) {
  return /* @__PURE__ */ u(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: e,
      children: [
        /* @__PURE__ */ a("path", { d: "M9 18V5l12-2v13" }),
        /* @__PURE__ */ a("circle", { cx: "6", cy: "18", r: "3" }),
        /* @__PURE__ */ a("circle", { cx: "18", cy: "16", r: "3" })
      ]
    }
  );
}
const pe = c((e, r) => {
  const { size: t, variant: n, className: o, ...s } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      role: "status",
      "aria-label": "Loading",
      className: l(
        "inline-block animate-spin rounded-full",
        "border-2 border-current border-t-transparent",
        Wa(t),
        qa(n),
        o
      ),
      ...s,
      children: /* @__PURE__ */ a("span", { className: "sr-only", children: "Loading..." })
    }
  );
});
pe.displayName = "Spinner";
function Ms({ size: e = "md", className: r }) {
  return /* @__PURE__ */ a("div", { className: l("flex items-center justify-center h-full w-full", r), children: /* @__PURE__ */ a(pe, { size: e }) });
}
const Ka = {
  xs: "h-3 w-3",
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12"
};
function Wa(e) {
  return Ka[e || "md"];
}
const Xa = {
  default: "text-foreground-muted",
  primary: "text-button-primary",
  white: "text-white",
  muted: "text-foreground-muted/50"
};
function qa(e) {
  return Xa[e || "default"];
}
const Ya = c((e, r) => {
  const { visible: t = !0, size: n = "lg", className: o, children: s, ...i } = e;
  return t ? /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l(
        "absolute inset-0 z-50 flex items-center justify-center",
        "bg-background/80 backdrop-blur-sm",
        o
      ),
      ...i,
      children: s || /* @__PURE__ */ a(pe, { size: n })
    }
  ) : null;
});
Ya.displayName = "LoadingOverlay";
const Ja = c((e, r) => {
  const { stats: t, layout: n = "row", size: o = "sm", className: s, ...i } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l("flex", n === "row" ? "flex-row gap-4" : "flex-wrap gap-2", s),
      ...i,
      children: t.map((d, m) => /* @__PURE__ */ a(Qa, { stat: d, size: o, layout: n }, m))
    }
  );
});
Ja.displayName = "StatBar";
function Qa({
  stat: e,
  size: r,
  layout: t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      className: l(
        "flex items-center gap-1.5",
        t === "grid" && "min-w-[80px]",
        to(r)
      ),
      children: [
        e.icon && /* @__PURE__ */ a("span", { className: "text-foreground-muted flex-shrink-0", children: e.icon }),
        /* @__PURE__ */ u("div", { className: "flex flex-col", children: [
          /* @__PURE__ */ a("span", { className: "font-medium text-foreground tabular-nums", children: e.value }),
          /* @__PURE__ */ u("span", { className: "text-foreground-muted text-[10px] leading-tight", children: [
            e.label,
            e.sublabel && /* @__PURE__ */ a("span", { className: "ml-1 opacity-70", children: e.sublabel })
          ] })
        ] })
      ]
    }
  );
}
const eo = {
  sm: "text-xs",
  md: "text-sm"
};
function to(e) {
  return eo[e];
}
const ro = 5, no = c((e, r) => {
  const { steps: t, currentStep: n, onStepClick: o, variant: s = "auto", className: i, ...d } = e, f = ke(() => s === "auto" ? t.length > ro ? "compact" : "full" : s, [s, t.length]) === "compact", p = t.length > 1 ? n / (t.length - 1) * 100 : 0, h = t[n];
  return /* @__PURE__ */ u("nav", { ref: r, "aria-label": "Progress", className: l("w-full", i), ...d, children: [
    /* @__PURE__ */ u("div", { className: "relative", children: [
      /* @__PURE__ */ a(
        "div",
        {
          className: l(
            "absolute h-0.5 -translate-y-1/2 bg-border",
            f ? "top-2.5 md:top-3 left-2.5 md:left-3 right-2.5 md:right-3" : "top-3 md:top-4 left-3 md:left-4 right-3 md:right-4"
          )
        }
      ),
      /* @__PURE__ */ a(
        "div",
        {
          className: l(
            "absolute h-0.5 -translate-y-1/2 bg-button-primary transition-all duration-300",
            f ? "top-2.5 md:top-3 left-2.5 md:left-3" : "top-3 md:top-4 left-3 md:left-4"
          ),
          style: {
            // Track spans from first circle center to last circle center
            // Compact: mobile 20px, desktop 24px. Full: mobile 24px, desktop 32px
            width: `calc((100% - ${f ? "20px" : "24px"}) * ${p / 100})`
          }
        }
      ),
      /* @__PURE__ */ a("ol", { className: "relative flex justify-between", children: t.map((b, N) => {
        const g = N < n, x = N === n, w = g && !!o;
        return /* @__PURE__ */ a("li", { children: /* @__PURE__ */ u(
          "button",
          {
            type: "button",
            onClick: () => w && o(N),
            disabled: !w,
            "aria-current": x ? "step" : void 0,
            className: l(
              "flex flex-col items-center gap-1.5 group",
              w && "cursor-pointer",
              !w && "cursor-default"
            ),
            children: [
              /* @__PURE__ */ a(
                "span",
                {
                  className: l(
                    "relative z-10 rounded-full flex items-center justify-center font-medium transition-all",
                    f ? "w-5 h-5 md:w-6 md:h-6 text-[10px] md:text-xs" : "w-6 h-6 md:w-8 md:h-8 text-xs md:text-sm",
                    g && "bg-button-primary text-button-primary-foreground",
                    g && w && "group-hover:ring-4 group-hover:ring-button-primary/20",
                    x && "bg-button-primary text-button-primary-foreground ring-4 ring-button-primary/20",
                    !g && !x && "bg-background border-2 border-border text-foreground-muted"
                  ),
                  children: g ? /* @__PURE__ */ a(
                    bt,
                    {
                      className: l(
                        f ? "w-2.5 h-2.5 md:w-3 md:h-3" : "w-3 h-3 md:w-4 md:h-4"
                      ),
                      "aria-hidden": "true"
                    }
                  ) : N + 1
                }
              ),
              !f && /* @__PURE__ */ a(
                "span",
                {
                  className: l(
                    "hidden md:block text-xs whitespace-nowrap",
                    x ? "text-foreground font-medium" : "text-foreground-muted",
                    w && "group-hover:text-foreground"
                  ),
                  children: b.label
                }
              )
            ]
          }
        ) }, b.id);
      }) })
    ] }),
    h && /* @__PURE__ */ u("div", { className: l("text-center mt-3", !f && "md:hidden"), children: [
      /* @__PURE__ */ a("div", { className: "font-medium text-foreground", children: h.label }),
      /* @__PURE__ */ u("div", { className: "text-sm text-foreground-muted", children: [
        "Step ",
        n + 1,
        " of ",
        t.length
      ] })
    ] })
  ] });
});
no.displayName = "Stepper";
const ao = c((e, r) => {
  const { spans: t, totalMs: n, nowMs: o, height: s = 6, className: i, ...d } = e;
  return n <= 0 ? null : /* @__PURE__ */ u(
    "div",
    {
      ref: r,
      className: l(
        "relative w-full bg-foreground-muted/20 rounded-full overflow-hidden",
        i
      ),
      style: { height: s },
      ...d,
      children: [
        t.map((m) => /* @__PURE__ */ a(oo, { span: m, totalMs: n, height: s }, m.id)),
        o !== void 0 && o > 0 && /* @__PURE__ */ a(
          "div",
          {
            className: "absolute top-0 bottom-0 w-px bg-foreground-accent",
            style: { left: `${Math.min(o / n * 100, 100)}%` }
          }
        )
      ]
    }
  );
});
ao.displayName = "Timeline";
function oo({
  span: e,
  totalMs: r,
  height: t
}) {
  const n = e.startMs / r * 100, o = (e.durationMs || 1) / r * 100;
  return /* @__PURE__ */ a(
    "div",
    {
      className: l(
        "absolute top-0 rounded-full transition-all duration-150",
        lo(e.status),
        e.status === "running" && "animate-pulse"
      ),
      style: {
        left: `${n}%`,
        width: `${Math.max(o, 0.5)}%`,
        height: t,
        backgroundColor: e.color
      }
    }
  );
}
const so = {
  running: "bg-amber-500",
  complete: "bg-emerald-500",
  error: "bg-red-500"
};
function lo(e) {
  return so[e || "complete"];
}
const zs = J.Provider, Ls = J.Root, Os = J.Trigger, io = c((e, r) => {
  const { className: t, sideOffset: n = 4, ...o } = e;
  return /* @__PURE__ */ a(J.Portal, { children: /* @__PURE__ */ a(
    J.Content,
    {
      ref: r,
      sideOffset: n,
      className: l(
        "z-50 overflow-hidden rounded-md bg-gray-900 px-3 py-1.5",
        "text-xs text-white",
        "animate-in fade-in-0 zoom-in-95",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=top]:slide-in-from-bottom-2",
        t
      ),
      ...o
    }
  ) });
});
io.displayName = "TooltipContent";
const Vs = c(function(r, t) {
  const {
    nodes: n,
    renderNode: o,
    defaultExpanded: s = !0,
    expandedIds: i,
    onToggleNode: d,
    className: m,
    ...f
  } = r, [p, h] = A(() => s === !0 ? co(n) : Array.isArray(s) ? new Set(s) : /* @__PURE__ */ new Set()), b = i !== void 0, N = b ? i : p, g = k(
    (x) => {
      b ? d?.(x) : h((w) => {
        const T = new Set(w);
        return T.has(x) ? T.delete(x) : T.add(x), T;
      });
    },
    [b, d]
  );
  return /* @__PURE__ */ a("div", { ref: t, className: l("flex flex-col", m), ...f, children: n.map((x) => /* @__PURE__ */ a(
    We,
    {
      node: x,
      depth: 0,
      expandedIds: N,
      toggleNode: g,
      renderNode: o
    },
    x.id
  )) });
});
function We({
  node: e,
  depth: r,
  expandedIds: t,
  toggleNode: n,
  renderNode: o
}) {
  const s = t.has(e.id), i = e.children && e.children.length > 0;
  return /* @__PURE__ */ u(X, { children: [
    o(e, r, s, () => n(e.id)),
    i && s && /* @__PURE__ */ a(X, { children: e.children.map((m) => /* @__PURE__ */ a(
      We,
      {
        node: m,
        depth: r + 1,
        expandedIds: t,
        toggleNode: n,
        renderNode: o
      },
      m.id
    )) })
  ] });
}
function co(e) {
  const r = /* @__PURE__ */ new Set();
  function t(n) {
    for (const o of n)
      r.add(o.id), o.children && t(o.children);
  }
  return t(e), r;
}
function Fs({
  children: e,
  duration: r = 200,
  delay: t = 0,
  from: n = "opacity",
  className: o
}) {
  const s = n === "opacity" ? "fade-in" : n === "bottom" ? "fade-in-up" : "fade-in";
  return /* @__PURE__ */ a(
    "div",
    {
      className: l("animate-[var(--fade-animation)]", o),
      style: {
        "--fade-animation": `${s} ${r}ms ease-out ${t}ms both`
      },
      children: e
    }
  );
}
const mo = c((e, r) => {
  const {
    onLoadMore: t,
    hasMore: n,
    isLoading: o = !1,
    threshold: s = 100,
    loader: i,
    endMessage: d,
    children: m,
    className: f,
    ...p
  } = e, h = O(null), b = O(0), N = O(t);
  H(() => {
    N.current = t;
  }, [t]);
  const g = O(!0);
  return H(() => {
    const x = h.current;
    if (!x || !n) return;
    const w = new IntersectionObserver(
      (T) => {
        const E = T[0];
        if (!E) return;
        if (!E.isIntersecting) {
          g.current = !0;
          return;
        }
        Date.now() - b.current < 500 || g.current && n && (o || (g.current = !1, b.current = Date.now(), N.current()));
      },
      {
        rootMargin: `${s}px`,
        threshold: 0
      }
    );
    return w.observe(x), () => w.disconnect();
  }, [n, o, s]), /* @__PURE__ */ u("div", { ref: r, className: l("relative", f), ...p, children: [
    m,
    o && /* @__PURE__ */ a("div", { className: "py-4", children: i || /* @__PURE__ */ a(uo, {}) }),
    n && /* @__PURE__ */ a("div", { ref: h, className: "h-1" }),
    !n && d && /* @__PURE__ */ a("div", { className: "py-4 text-center text-sm text-gray-500", children: d })
  ] });
});
mo.displayName = "InfiniteScroll";
const uo = () => /* @__PURE__ */ u("div", { className: "space-y-3", children: [
  /* @__PURE__ */ a(F, { className: "h-20 w-full" }),
  /* @__PURE__ */ a(F, { className: "h-20 w-full" }),
  /* @__PURE__ */ a(F, { className: "h-20 w-full" })
] });
function js(e) {
  const [r, t] = A([]), [n, o] = A(1), [s, i] = A(!0), [d, m] = A(!1), [f, p] = A(null), h = O(!1), b = k(async () => {
    if (!(h.current || !s)) {
      h.current = !0, m(!0), p(null);
      try {
        const { items: g, hasMore: x } = await e(n);
        t((w) => [...w, ...g]), i(x && g.length > 0), o((w) => w + 1);
      } catch (g) {
        p(g instanceof Error ? g : new Error("Failed to load more")), i(!1);
      } finally {
        h.current = !1, m(!1);
      }
    }
  }, [n, e, s]), N = k(() => {
    t([]), o(1), i(!0), p(null);
  }, []);
  return {
    items: r,
    hasMore: s,
    isLoading: d,
    error: f,
    loadMore: b,
    reset: N
  };
}
const Xe = c((e, r) => {
  const {
    variant: t = "info",
    title: n,
    icon: o,
    showIcon: s = !0,
    className: i,
    children: d,
    ...m
  } = e, f = o !== void 0, p = go(t);
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      role: "alert",
      className: l("relative w-full rounded-lg border p-4", po(t), i),
      ...m,
      children: /* @__PURE__ */ u("div", { className: "flex gap-3", children: [
        s && /* @__PURE__ */ a("div", { className: "flex-shrink-0", children: f ? o : /* @__PURE__ */ a(p, { className: "h-5 w-5" }) }),
        /* @__PURE__ */ u("div", { className: "flex-1", children: [
          n && /* @__PURE__ */ a("h5", { className: "mb-1 font-medium leading-none tracking-tight", children: n }),
          d && /* @__PURE__ */ a("div", { className: "text-sm [&_p]:leading-relaxed", children: d })
        ] })
      ] })
    }
  );
});
Xe.displayName = "Alert";
const Hs = Xe, fo = {
  info: "border-blue-500/30 bg-blue-500/10 text-blue-300 [&_svg]:text-blue-400",
  success: "border-green-500/30 bg-green-500/10 text-green-300 [&_svg]:text-green-400",
  warning: "border-yellow-500/30 bg-yellow-500/10 text-yellow-300 [&_svg]:text-yellow-400",
  danger: "border-red-500/30 bg-red-500/10 text-red-300 [&_svg]:text-red-400",
  tip: "border-purple-500/30 bg-purple-500/10 text-purple-300 [&_svg]:text-purple-400",
  neutral: "border-border bg-background-secondary text-foreground [&_svg]:text-foreground-muted"
};
function po(e) {
  return fo[e];
}
function go(e) {
  return {
    info: be,
    success: ut,
    warning: _e,
    danger: mt,
    tip: ct,
    neutral: be
  }[e];
}
const ae = c((e, r) => {
  const {
    error: t,
    icon: n,
    showIcon: o = !0,
    variant: s = "default",
    size: i = "sm",
    className: d,
    children: m,
    ...f
  } = e;
  if (!t && !m) return null;
  const p = Array.isArray(t) ? t : [t || m], h = p.length > 1;
  return /* @__PURE__ */ u(
    B,
    {
      alignment: "center",
      ref: r,
      role: "alert",
      "aria-live": "polite",
      className: l(
        "items-center",
        bo(s),
        No(i),
        d
      ),
      ...f,
      children: [
        o && /* @__PURE__ */ a("span", { className: "flex-shrink-0", children: n || /* @__PURE__ */ a(_e, { className: vo(i) }) }),
        /* @__PURE__ */ a("div", { className: "flex-1", children: h ? /* @__PURE__ */ a("ul", { className: "list-disc list-inside space-y-1", children: p.map((b, N) => /* @__PURE__ */ a("li", { children: b }, N)) }) : /* @__PURE__ */ a("span", { children: p[0] }) })
      ]
    }
  );
});
ae.displayName = "ErrorMessage";
const ho = {
  default: "bg-error-background text-error-text border-error-border",
  muted: "text-red-500",
  bold: "text-red-700 font-medium",
  inline: "text-red-600 inline-flex items-center"
};
function bo(e) {
  return ho[e];
}
const xo = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg"
};
function No(e) {
  return xo[e];
}
const yo = {
  xs: "h-3 w-3",
  sm: "h-3.5 w-3.5",
  md: "h-4 w-4",
  lg: "h-5 w-5"
};
function vo(e) {
  return yo[e];
}
const wo = c((e, r) => {
  const { name: t, errors: n, ...o } = e;
  return !t || !n || !n[t] ? null : /* @__PURE__ */ a(ae, { ref: r, error: n[t], ...o });
});
wo.displayName = "FieldError";
const So = q.createContext(null);
So.displayName = "HookFormControlContext";
typeof window < "u" ? q.useLayoutEffect : q.useEffect;
const qe = q.createContext(null);
qe.displayName = "HookFormContext";
const Co = () => q.useContext(qe), To = Ie({}), Ao = c((e, r) => {
  const { errors: t, disabled: n, className: o, children: s, ...i } = e, d = t?._form || t?.root;
  return /* @__PURE__ */ a(To.Provider, { value: { errors: t, disabled: n }, children: /* @__PURE__ */ u("form", { ref: r, className: l("space-y-6", o), ...i, children: [
    d && /* @__PURE__ */ a(ae, { error: d }),
    s
  ] }) });
});
Ao.displayName = "Form";
const Io = c((e, r) => {
  const {
    name: t,
    label: n,
    description: o,
    required: s,
    error: i,
    className: d,
    children: m,
    ...f
  } = e;
  let p = i;
  const h = Co();
  if (h?.formState?.errors && t) {
    const b = h?.formState?.errors[t];
    p = b?.message || b || i;
  }
  return /* @__PURE__ */ u("div", { ref: r, className: l("space-y-2 w-full", d), ...f, children: [
    n && /* @__PURE__ */ a(Ye, { variant: e.labelVariant, htmlFor: t, required: s, children: n }),
    m,
    o && !p && /* @__PURE__ */ a(ge, { children: o }),
    p && /* @__PURE__ */ a(ae, { error: typeof p == "string" ? p : p.message, size: "sm" })
  ] });
});
Io.displayName = "FormField";
const ko = {
  default: "text-foreground-muted text-sm",
  prominent: "text-foreground-accent text-md"
}, Ye = c((e, r) => {
  const { variant: t = "default", required: n, className: o, children: s, ...i } = e;
  return /* @__PURE__ */ u(
    "label",
    {
      ref: r,
      className: l("block w-full", ko[t], o),
      ...i,
      children: [
        s,
        n && /* @__PURE__ */ a("span", { className: "ml-1 text-button-destructive", "aria-label": "required", children: "*" })
      ]
    }
  );
});
Ye.displayName = "FormLabel";
const ge = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a("p", { ref: r, className: l("text-sm text-gray-600", t), ...n });
});
ge.displayName = "Description";
const Po = c((e, r) => {
  const { title: t, description: n, className: o, children: s, ...i } = e;
  return /* @__PURE__ */ u("fieldset", { ref: r, className: l("space-y-4 ", o), ...i, children: [
    (t || n) && /* @__PURE__ */ u("div", { className: "space-y-1 w-full ", children: [
      t && /* @__PURE__ */ a("div", { className: "text-lg font-semibold text-foreground-accent ", children: t }),
      n && /* @__PURE__ */ a(ge, { children: n })
    ] }),
    s
  ] });
});
Po.displayName = "FormSection";
const Eo = c((e, r) => {
  const { className: t, ...n } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l("flex items-center justify-end gap-3 pt-6 border-t w-full", t),
      ...n
    }
  );
});
Eo.displayName = "FormActions";
const Do = c((e, r) => {
  const { columns: t = "auto", className: n, ...o } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      className: l("w-full grid gap-6", {
        1: "grid-cols-1",
        2: "grid-cols-1 sm:grid-cols-2",
        3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
        auto: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
      }[t], n),
      ...o
    }
  );
});
Do.displayName = "FormRow";
const Ro = c((e, r) => {
  const { required: t, disabled: n, error: o, className: s, children: i, ...d } = e;
  return /* @__PURE__ */ u(
    "label",
    {
      ref: r,
      className: l(
        "inline-block text-sm font-medium",
        n ? "text-foreground-muted/50 cursor-not-allowed" : "text-foreground-muted",
        o && "text-red-600",
        s
      ),
      ...d,
      children: [
        i,
        t && /* @__PURE__ */ a("span", { className: "ml-1 text-red-500", "aria-label": "required", children: "*" })
      ]
    }
  );
});
Ro.displayName = "Label";
const _o = {
  default: "border border-border-secondary bg-background-secondary text-foreground",
  ghost: "border-transparent bg-transparent text-foreground"
}, Mo = {
  sm: "px-2 py-1.5 text-sm",
  md: "px-3 py-2 text-base",
  lg: "px-4 py-3 text-lg"
}, zo = c((e, r) => {
  const { variant: t = "default", size: n = "md", className: o, ...s } = e;
  return /* @__PURE__ */ a(
    "textarea",
    {
      ref: r,
      className: l(
        "rounded-md transition-colors w-full resize-y min-h-[80px]",
        "focus:outline-none focus:ring-2 focus:ring-button-primary focus:ring-offset-1 focus:ring-offset-background",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "placeholder:text-foreground-muted",
        "hover:border-border-secondary",
        _o[t],
        Mo[n],
        o
      ),
      ...s
    }
  );
});
zo.displayName = "Textarea";
const Bs = I.Root, Gs = I.Trigger, Lo = c((e, r) => {
  const { className: t, align: n = "end", sideOffset: o = 8, ...s } = e;
  return /* @__PURE__ */ a(I.Portal, { children: /* @__PURE__ */ a(
    I.Content,
    {
      ref: r,
      align: n,
      sideOffset: o,
      className: l(
        // Width constraints (content-driven)
        "min-w-72 max-w-96",
        // Height constraints
        "max-h-[min(480px,calc(100vh-120px))]",
        // Layout
        "flex flex-col overflow-hidden",
        // Appearance
        "z-50 rounded-md border border-border bg-surface-elevated shadow-md outline-none",
        // Animations
        "data-[state=open]:animate-in data-[state=closed]:animate-out",
        "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        "data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=top]:slide-in-from-bottom-2",
        t
      ),
      ...s
    }
  ) });
});
Lo.displayName = "ActivityPanelContent";
function Oo({
  title: e,
  count: r,
  countLabel: t,
  children: n,
  className: o
}) {
  const s = r !== void 0 && r > 0;
  return /* @__PURE__ */ u(
    "div",
    {
      className: l(
        "flex items-center justify-between px-4 py-3 border-b border-border",
        o
      ),
      children: [
        /* @__PURE__ */ u("h2", { className: "text-sm font-semibold text-foreground", children: [
          e,
          s && /* @__PURE__ */ u("span", { className: "ml-2 text-xs font-normal text-foreground-muted", children: [
            "(",
            r,
            " ",
            t ?? "",
            ")"
          ] })
        ] }),
        n && /* @__PURE__ */ a("div", { className: "flex items-center gap-2", children: n })
      ]
    }
  );
}
Oo.displayName = "ActivityPanelHeader";
function Vo({ children: e, className: r }) {
  return /* @__PURE__ */ a("div", { className: l("flex-1 overflow-y-auto overflow-x-hidden p-2", r), children: e });
}
Vo.displayName = "ActivityPanelBody";
function Fo({ children: e, className: r }) {
  return /* @__PURE__ */ a("div", { className: l("space-y-1", r), children: e });
}
Fo.displayName = "ActivityPanelSection";
function jo({
  children: e,
  count: r,
  className: t
}) {
  return /* @__PURE__ */ u(
    "h3",
    {
      className: l(
        "text-xs font-semibold text-foreground-muted uppercase tracking-wider px-3 py-2",
        t
      ),
      children: [
        e,
        r !== void 0 && r > 0 && /* @__PURE__ */ u("span", { className: "ml-1", children: [
          "(",
          r,
          ")"
        ] })
      ]
    }
  );
}
jo.displayName = "ActivityPanelSectionHeader";
function Ho({ children: e, divided: r = !0, className: t }) {
  return /* @__PURE__ */ a("div", { className: l(r && "divide-y divide-border", "space-y-0.5", t), children: e });
}
Ho.displayName = "ActivityPanelList";
function Bo({ children: e, className: r }) {
  return /* @__PURE__ */ a(
    "div",
    {
      className: l("border-t border-border px-4 py-2 flex items-center justify-center", r),
      children: e
    }
  );
}
Bo.displayName = "ActivityPanelFooter";
function Go({
  icon: e,
  title: r,
  description: t,
  className: n
}) {
  return /* @__PURE__ */ u("div", { className: l("flex flex-col items-center justify-center py-8 px-4", n), children: [
    e && /* @__PURE__ */ a("div", { className: "text-foreground-muted mb-2", children: e }),
    /* @__PURE__ */ a("p", { className: "text-sm text-foreground-muted", children: r }),
    t && /* @__PURE__ */ a("p", { className: "text-xs text-foreground-muted/70 mt-1", children: t })
  ] });
}
Go.displayName = "ActivityPanelEmptyState";
const $o = {
  default: {
    indicator: "bg-foreground-muted",
    iconActive: ""
  },
  progress: {
    indicator: "bg-progress-fill",
    iconActive: "text-progress-fill"
  },
  error: {
    indicator: "bg-error",
    iconActive: "text-error/70 hover:text-error"
  }
}, Zo = c(
  ({
    icon: e,
    count: r,
    variant: t = "default",
    maxCount: n = 99,
    className: o,
    "aria-label": s,
    ...i
  }, d) => {
    const m = r !== void 0 && r > 0, f = m ? r > n ? `${n}+` : r : null, p = $o[t];
    return /* @__PURE__ */ u(
      "button",
      {
        ref: d,
        type: "button",
        className: l(
          "relative inline-flex items-center justify-center rounded-md p-2 transition-colors",
          "text-foreground-muted hover:text-foreground hover:bg-hover-overlay",
          "focus:outline-none focus-visible:ring-2 focus-visible:ring-focus-ring",
          m && p.iconActive,
          o
        ),
        "aria-label": s,
        ...i,
        children: [
          e,
          m && /* @__PURE__ */ a(
            "span",
            {
              className: l(
                "absolute -top-0.5 -right-0.5 flex items-center justify-center",
                "min-w-[18px] h-[18px] px-1 rounded-full",
                "text-xs font-medium text-foreground-inverse",
                p.indicator
              ),
              children: f
            }
          )
        ]
      }
    );
  }
);
Zo.displayName = "ActivityPanelBadge";
function Uo(e) {
  const { itemCount: r, autoAdvance: t = 0, loop: n = !0, onChange: o } = e, [s, i] = A(0), [d, m] = A(!1), f = O(null), p = k(
    (x) => {
      x < 0 || x >= r || i(x);
    },
    [r]
  ), h = k(() => {
    i((x) => {
      const w = x + 1;
      return w >= r ? n ? 0 : x : w;
    });
  }, [r, n]), b = k(() => {
    i((x) => {
      const w = x - 1;
      return w < 0 ? n ? r - 1 : x : w;
    });
  }, [r, n]), N = k(() => m(!0), []), g = k(() => m(!1), []);
  return H(() => {
    o?.(s);
  }, [s, o]), H(() => (t > 0 && !d && r > 1 && (f.current = setInterval(h, t)), () => {
    f.current && clearInterval(f.current);
  }), [t, d, h, r]), {
    currentIndex: s,
    goTo: p,
    goNext: h,
    goPrev: b,
    pause: N,
    resume: g,
    isPaused: d
  };
}
function Ko(e) {
  const { onSwipeLeft: r, onSwipeRight: t, threshold: n = 50 } = e, o = O(null), s = k((d) => {
    o.current = d.touches[0].clientX;
  }, []), i = k(
    (d) => {
      if (o.current === null) return;
      const m = d.changedTouches[0].clientX - o.current;
      Math.abs(m) > n && (m > 0 ? t?.() : r?.()), o.current = null;
    },
    [r, t, n]
  );
  return { onTouchStart: s, onTouchEnd: i };
}
const Je = c((e, r) => {
  const { count: t, activeIndex: n, onDotClick: o, className: s, ...i } = e;
  return t <= 1 ? null : /* @__PURE__ */ a(
    "div",
    {
      ref: r,
      role: "tablist",
      "aria-label": "Carousel navigation",
      className: l("flex items-center justify-center gap-2", s),
      ...i,
      children: Array.from({ length: t }, (d, m) => /* @__PURE__ */ a(
        "button",
        {
          role: "tab",
          "aria-selected": m === n,
          "aria-label": `Go to slide ${m + 1}`,
          onClick: () => o?.(m),
          className: l(
            "h-2 w-2 rounded-full transition-all duration-200",
            m === n ? "bg-foreground w-4" : "bg-foreground/30 hover:bg-foreground/50"
          )
        },
        m
      ))
    }
  );
});
Je.displayName = "CarouselDots";
const Wo = c((e, r) => {
  const {
    children: t,
    autoAdvance: n = 0,
    loop: o = !0,
    showDots: s = !0,
    showArrows: i = !0,
    onChange: d,
    className: m,
    ...f
  } = e, p = tt.toArray(t), { currentIndex: h, goTo: b, goNext: N, goPrev: g, pause: x, resume: w } = Uo({
    itemCount: p.length,
    autoAdvance: n,
    loop: o,
    onChange: d
  }), T = Ko({
    onSwipeLeft: N,
    onSwipeRight: g
  }), E = k(
    (S) => {
      switch (S.key) {
        case "ArrowLeft":
          S.preventDefault(), g();
          break;
        case "ArrowRight":
          S.preventDefault(), N();
          break;
      }
    },
    [N, g]
  ), v = O(!1), y = k(
    (S) => {
      v.current || Math.abs(S.deltaX) < 10 || (v.current = !0, setTimeout(() => v.current = !1, 300), S.deltaX > 0 ? N() : g());
    },
    [N, g]
  );
  return p.length === 0 ? null : /* @__PURE__ */ u(
    "div",
    {
      ref: r,
      role: "region",
      "aria-roledescription": "carousel",
      "aria-label": "Featured content",
      tabIndex: 0,
      className: l("relative w-full h-full outline-none", m),
      onMouseEnter: x,
      onMouseLeave: w,
      onFocus: x,
      onBlur: w,
      onKeyDown: E,
      onTouchStart: T.onTouchStart,
      onTouchEnd: T.onTouchEnd,
      onWheel: y,
      ...f,
      children: [
        /* @__PURE__ */ a("div", { className: "relative w-full h-full overflow-hidden", children: p.map((S, C) => /* @__PURE__ */ a(
          "div",
          {
            role: "tabpanel",
            "aria-hidden": C !== h,
            className: l(
              "absolute inset-0 transition-opacity duration-300",
              C === h ? "opacity-100 z-10" : "opacity-0 z-0 pointer-events-none"
            ),
            children: S
          },
          C
        )) }),
        i && p.length > 1 && /* @__PURE__ */ u(X, { children: [
          /* @__PURE__ */ a(
            "button",
            {
              type: "button",
              onClick: g,
              "aria-label": "Previous slide",
              className: "hidden md:flex absolute left-2 top-1/2 -translate-y-1/2 z-20 p-2 rounded-full bg-glass-tint/60 backdrop-blur-sm border border-glass-border text-foreground/70 hover:bg-glass-tint/80 hover:text-foreground transition-colors",
              children: /* @__PURE__ */ a(xt, { className: "w-5 h-5" })
            }
          ),
          /* @__PURE__ */ a(
            "button",
            {
              type: "button",
              onClick: N,
              "aria-label": "Next slide",
              className: "hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 z-20 p-2 rounded-full bg-glass-tint/60 backdrop-blur-sm border border-glass-border text-foreground/70 hover:bg-glass-tint/80 hover:text-foreground transition-colors",
              children: /* @__PURE__ */ a(Nt, { className: "w-5 h-5" })
            }
          )
        ] }),
        s && p.length > 1 && /* @__PURE__ */ a("div", { className: "absolute bottom-14 left-0 right-0 z-20", children: /* @__PURE__ */ a(Je, { count: p.length, activeIndex: h, onDotClick: b }) })
      ]
    }
  );
});
Wo.displayName = "Carousel";
function $s({
  dimension: e,
  value: r,
  onChange: t,
  size: n = "md",
  disabled: o,
  showDescription: s,
  placeholder: i,
  className: d
}) {
  return /* @__PURE__ */ a(
    Le,
    {
      size: n,
      value: r,
      onValueChange: (m) => t(m),
      disabled: o,
      placeholder: i,
      className: d,
      children: e.Options.map((m) => /* @__PURE__ */ a(Oe, { value: m.value, children: s ? `${m.label} - ${m.description}` : m.label }, m.value))
    }
  );
}
function Zs({
  dimension: e,
  value: r,
  onChange: t,
  size: n = "md",
  disabled: o,
  fullWidth: s,
  surface: i = "secondary",
  className: d
}) {
  const m = e.Options.map((f) => ({
    value: f.value,
    label: f.label
  }));
  return /* @__PURE__ */ a(
    Be,
    {
      value: r,
      onValueChange: (f) => t(f),
      options: m,
      size: n,
      disabled: o,
      fullWidth: s,
      surface: i,
      className: d
    }
  );
}
function Us({
  label: e,
  description: r,
  children: t,
  labelWidth: n = "w-20",
  className: o
}) {
  return /* @__PURE__ */ u(B, { alignment: "center", className: l("w-full gap-3", o), children: [
    /* @__PURE__ */ u("div", { className: l("shrink-0", n), children: [
      /* @__PURE__ */ a("span", { className: "text-xs text-foreground-muted", children: e }),
      r && /* @__PURE__ */ a("span", { className: "block text-[10px] text-foreground-muted/70", children: r })
    ] }),
    /* @__PURE__ */ a("div", { className: "flex-1", children: t })
  ] });
}
const Xo = {
  sm: "gap-2",
  md: "gap-3"
};
function Ks({ title: e, children: r, spacing: t = "sm", className: n }) {
  return /* @__PURE__ */ u(Z, { alignment: "leading", className: l("w-full", Xo[t], n), children: [
    e && /* @__PURE__ */ a("div", { className: "w-full border-b border-border/30 pb-1", children: /* @__PURE__ */ a("span", { className: "text-xs font-medium text-foreground-accent-muted uppercase tracking-wide", children: e }) }),
    r
  ] });
}
function Ws({ title: e, children: r, className: t }) {
  return /* @__PURE__ */ a(ce, { variant: "default", padding: "md", className: l("flex-1", t), children: /* @__PURE__ */ u(Z, { alignment: "leading", spacing: "md", children: [
    /* @__PURE__ */ a("span", { className: "text-sm font-semibold text-foreground-accent uppercase tracking-wide", children: e }),
    r
  ] }) });
}
const qo = {
  sm: "backdrop-blur-sm",
  md: "backdrop-blur-md",
  lg: "backdrop-blur-lg"
}, Yo = {
  light: "bg-glass-tint/40",
  medium: "bg-glass-tint/60",
  heavy: "bg-glass-tint/80"
}, Jo = c((e, r) => {
  const { blur: t = "md", opacity: n = "medium", className: o, ...s } = e;
  return /* @__PURE__ */ a(
    ce,
    {
      ref: r,
      variant: "ghost",
      className: l(
        qo[t],
        Yo[n],
        "border border-glass-border",
        o
      ),
      ...s
    }
  );
});
Jo.displayName = "GlassCard";
const Qo = c((e, r) => {
  const {
    artwork: t,
    content: n,
    metadata: o,
    trailing: s,
    variant: i = "default",
    className: d,
    testId: m,
    ...f
  } = e;
  return /* @__PURE__ */ u(
    B,
    {
      ref: r,
      className: l(
        "group w-full p-3 rounded-lg cursor-pointer items-center gap-3",
        i === "default" && "bg-background-secondary hover:bg-surface-elevated",
        i === "ghost" && "hover:bg-background-secondary",
        d
      ),
      alignment: "leading",
      "data-testid": m,
      ...f,
      children: [
        /* @__PURE__ */ a("div", { className: "shrink-0", children: t }),
        /* @__PURE__ */ a("div", { className: "min-w-0 flex-1", children: n }),
        o && /* @__PURE__ */ a("div", { className: "shrink-0", children: o }),
        s && /* @__PURE__ */ a("div", { className: "shrink-0", children: s })
      ]
    }
  );
});
Qo.displayName = "MediaCardLayout";
function Xs(e) {
  const { title: r, subtitle: t, className: n } = e;
  return /* @__PURE__ */ u(Z, { alignment: "leading", spacing: "xs", className: l("min-w-0 max-w-full", n), children: [
    /* @__PURE__ */ a(ie, { color: "default", weight: "semibold", size: "sm", className: "truncate w-full", children: r }),
    t && /* @__PURE__ */ a(ie, { color: "muted", size: "sm", className: "truncate w-full", children: t })
  ] });
}
const es = {
  sm: "max-w-[min(90vw,400px)]",
  default: "max-w-[min(90vw,600px)]",
  lg: "max-w-[min(90vw,800px)]",
  full: "max-w-[90vw]"
};
function oe({
  open: e,
  onOpenChange: r,
  maxWidth: t = "default",
  showClose: n = !0,
  mobileFullscreen: o = !1,
  title: s,
  className: i,
  children: d
}) {
  const m = () => r(!1);
  return /* @__PURE__ */ a(mn, { open: e, onOpenChange: r, children: /* @__PURE__ */ u(
    Ze,
    {
      showClose: o ? !1 : n,
      "aria-describedby": void 0,
      className: l(
        es[t],
        o && [
          // Mobile: fullscreen takeover
          "max-md:fixed max-md:inset-0 max-md:translate-x-0 max-md:translate-y-0",
          "max-md:left-0 max-md:top-0 max-md:w-full max-md:h-full",
          "max-md:max-w-none max-md:max-h-none max-md:min-w-0",
          "max-md:rounded-none max-md:border-0"
        ],
        i
      ),
      children: [
        o && /* @__PURE__ */ u(X, { children: [
          /* @__PURE__ */ u("div", { className: "flex-shrink-0 h-14 px-4 flex items-center gap-3 border-b border-border md:hidden", children: [
            /* @__PURE__ */ a(
              "button",
              {
                type: "button",
                onClick: m,
                className: "p-2 -ml-2 hover:bg-hover-overlay rounded-md",
                children: /* @__PURE__ */ a(ft, { className: "w-5 h-5" })
              }
            ),
            s && /* @__PURE__ */ a("span", { className: "font-semibold truncate", children: s })
          ] }),
          n && /* @__PURE__ */ a(P.Close, { className: "absolute right-4 top-4 rounded-sm text-sonify-muted hover:text-sonify-white transition-colors z-10 hidden md:block", children: /* @__PURE__ */ a(K, { className: "h-4 w-4" }) })
        ] }),
        d
      ]
    }
  ) });
}
function qs({
  open: e,
  onOpenChange: r,
  maxWidth: t = "default",
  mobileFullscreen: n = !1,
  title: o,
  description: s,
  onSubmit: i,
  onCancel: d,
  submitLabel: m = "Submit",
  cancelLabel: f = "Cancel",
  submitDisabled: p = !1,
  submitLoading: h = !1,
  submitVariant: b = "primary",
  children: N
}) {
  const g = h;
  return /* @__PURE__ */ u(
    oe,
    {
      open: e,
      onOpenChange: r,
      maxWidth: t,
      showClose: !g,
      mobileFullscreen: n,
      title: o,
      className: "w-full",
      children: [
        /* @__PURE__ */ u(ee, { children: [
          /* @__PURE__ */ a(U, { children: o }),
          s && /* @__PURE__ */ a(ne, { children: s })
        ] }),
        /* @__PURE__ */ a("div", { className: "border-t border-white/10", children: /* @__PURE__ */ a(re, { className: "py-5", children: N }) }),
        /* @__PURE__ */ a("div", { className: "border-t border-white/10", children: /* @__PURE__ */ u(me, { children: [
          /* @__PURE__ */ a(z, { variant: "ghost", onClick: () => {
            g || d?.();
          }, disabled: g, children: f }),
          /* @__PURE__ */ a(
            z,
            {
              variant: b,
              onClick: () => {
                g || p || i?.();
              },
              disabled: p || g,
              children: g ? "..." : m
            }
          )
        ] }) })
      ]
    }
  );
}
function Ys({
  open: e,
  onOpenChange: r,
  maxWidth: t = "default",
  title: n,
  description: o,
  children: s
}) {
  return /* @__PURE__ */ u(oe, { open: e, onOpenChange: r, maxWidth: t, children: [
    /* @__PURE__ */ u(ee, { children: [
      /* @__PURE__ */ a(U, { children: n }),
      o && /* @__PURE__ */ a(ne, { children: o })
    ] }),
    /* @__PURE__ */ a("div", { className: "border-t border-white/10", children: /* @__PURE__ */ a(re, { className: "py-5", children: s }) })
  ] });
}
function Js({
  open: e,
  onOpenChange: r,
  title: t,
  description: n,
  onConfirm: o,
  onCancel: s,
  confirmLabel: i = "Confirm",
  cancelLabel: d = "Cancel",
  variant: m = "default",
  isLoading: f = !1
}) {
  const [p, h] = A(!1), b = f || p, N = k(() => {
    b || (s?.(), r(!1));
  }, [b, s, r]), g = k(async () => {
    if (!b) {
      h(!0);
      try {
        await o(), r(!1);
      } finally {
        h(!1);
      }
    }
  }, [b, o, r]);
  return /* @__PURE__ */ u(oe, { open: e, onOpenChange: r, maxWidth: "sm", showClose: !b, children: [
    /* @__PURE__ */ u(ee, { children: [
      /* @__PURE__ */ a(U, { children: t }),
      n && /* @__PURE__ */ a(ne, { children: n })
    ] }),
    /* @__PURE__ */ a("div", { className: "border-t border-white/10", children: /* @__PURE__ */ u(me, { children: [
      /* @__PURE__ */ a(z, { variant: "ghost", onClick: N, disabled: b, children: d }),
      /* @__PURE__ */ a(
        z,
        {
          variant: m === "danger" ? "danger" : "primary",
          onClick: () => {
            g();
          },
          disabled: b,
          children: b ? "..." : i
        }
      )
    ] }) })
  ] });
}
function Qs({
  open: e,
  onOpenChange: r,
  maxWidth: t = "default",
  title: n,
  description: o,
  icon: s,
  options: i,
  layout: d = "horizontal"
}) {
  const m = (f) => {
    f.onClick(), r(!1);
  };
  return /* @__PURE__ */ u(oe, { open: e, onOpenChange: r, maxWidth: t, children: [
    /* @__PURE__ */ a(ee, { children: s ? /* @__PURE__ */ u(B, { className: "items-center gap-2", children: [
      s,
      /* @__PURE__ */ a(U, { children: n })
    ] }) : /* @__PURE__ */ a(U, { children: n }) }),
    /* @__PURE__ */ a("div", { className: "border-t border-white/10 bg-white/[0.02]", children: /* @__PURE__ */ u(re, { className: "py-5", children: [
      o && /* @__PURE__ */ a("div", { className: "mb-6", children: o }),
      d === "horizontal" ? /* @__PURE__ */ a("div", { className: "flex flex-col sm:flex-row gap-3 sm:gap-4", children: i.map((f) => /* @__PURE__ */ u(
        z,
        {
          variant: f.variant ?? "primary",
          size: "lg",
          className: "flex-1",
          onClick: () => m(f),
          children: [
            f.icon && /* @__PURE__ */ a("span", { className: "mr-2", children: f.icon }),
            f.label
          ]
        },
        f.label
      )) }) : /* @__PURE__ */ a(Z, { className: "gap-3", children: i.map((f) => /* @__PURE__ */ a(
        "button",
        {
          type: "button",
          onClick: () => m(f),
          className: "w-full p-4 rounded-lg border border-sonify-gray/30 hover:border-sonify-cyan/50 hover:bg-sonify-gray/10 transition-colors text-left",
          children: /* @__PURE__ */ u(B, { className: "items-center gap-3", children: [
            f.icon && /* @__PURE__ */ a("span", { className: "flex-shrink-0 text-sonify-cyan", children: f.icon }),
            /* @__PURE__ */ u(Z, { className: "gap-1", children: [
              /* @__PURE__ */ a("span", { className: "font-medium text-sonify-white", children: f.label }),
              f.description && /* @__PURE__ */ a("span", { className: "text-sm text-sonify-muted", children: f.description })
            ] })
          ] })
        },
        f.label
      )) })
    ] }) })
  ] });
}
const Ae = {
  muted: "bg-muted/30 border-border/50",
  elevated: "bg-surface-elevated border-border/60",
  overlay: "bg-surface-overlay border-border/70"
};
function el({ tabs: e, defaultTab: r, surface: t = "muted", className: n }) {
  const o = e.filter((m) => m.content != null), s = r && o.some((m) => m.id === r) ? r : o[0]?.id, [i, d] = A(s);
  return o.length === 0 ? /* @__PURE__ */ a("div", { className: l("rounded border overflow-hidden", Ae[t], n), children: /* @__PURE__ */ a("div", { className: "text-foreground-muted/50 italic text-center py-4 text-[11px]", children: "No content" }) }) : /* @__PURE__ */ u(
    j.Root,
    {
      value: i,
      onValueChange: d,
      className: l("rounded border overflow-hidden", Ae[t], n),
      children: [
        /* @__PURE__ */ a(j.List, { className: "flex gap-4 px-3 pt-2 border-b border-border/30", children: o.map((m) => /* @__PURE__ */ a(
          j.Trigger,
          {
            value: m.id,
            className: l(
              "relative text-[11px] pb-2",
              "text-foreground-muted transition-colors",
              "hover:text-foreground",
              "data-[state=active]:text-foreground",
              // Active underline
              "after:absolute after:bottom-0 after:left-0 after:right-0",
              "after:h-[2px] after:bg-foreground-accent",
              "after:scale-x-0 data-[state=active]:after:scale-x-100",
              "after:transition-transform after:duration-150",
              "focus-visible:outline-none"
            ),
            children: m.label
          },
          m.id
        )) }),
        o.map((m) => /* @__PURE__ */ a(
          j.Content,
          {
            value: m.id,
            className: "px-3 py-2 max-h-64 overflow-auto focus-visible:outline-none",
            children: m.content
          },
          m.id
        ))
      ]
    }
  );
}
function tl(e) {
  const r = O(null);
  return H(() => {
    const n = document.createElement("input");
    n.type = "file", n.accept = e?.accept || "*", n.multiple = e?.multiple ?? !1, n.style.display = "none", n.onchange = (o) => {
      const s = o.target.files;
      s && e?.onFilesSelected && e.onFilesSelected(Array.from(s));
    }, r.current = n;
  }, [e, e?.accept, e?.multiple]), { open: () => r.current?.click() };
}
const $ = {
  base: 0,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
};
function rl() {
  const [e, r] = A(() => typeof window > "u" ? "base" : se());
  H(() => {
    if (typeof window > "u") return;
    if (typeof window.matchMedia == "function") {
      const s = Object.entries($).filter(([d]) => d !== "base").map(([d, m]) => ({
        key: d,
        mq: window.matchMedia(`(min-width: ${m}px)`)
      })), i = () => {
        r(se());
      };
      return i(), s.forEach(({ mq: d }) => {
        d.addEventListener("change", i);
      }), () => {
        s.forEach(({ mq: d }) => {
          d.removeEventListener("change", i);
        });
      };
    }
    function o() {
      r(se());
    }
    return window.addEventListener("resize", o), () => window.removeEventListener("resize", o);
  }, []);
  const t = k(
    (o) => {
      const s = ["base", "sm", "md", "lg", "xl", "2xl"];
      return s.indexOf(e) >= s.indexOf(o);
    },
    [e]
  ), n = k(
    (o) => {
      const s = ["base", "sm", "md", "lg", "xl", "2xl"];
      return s.indexOf(e) <= s.indexOf(o);
    },
    [e]
  );
  return ke(
    () => ({
      breakpoint: e,
      isMobile: e === "base" || e === "sm",
      isTablet: e === "md",
      isDesktop: e === "lg" || e === "xl" || e === "2xl",
      isAtLeast: t,
      isAtMost: n
    }),
    [e, t, n]
  );
}
function se() {
  if (typeof window > "u") return "base";
  const e = window.innerWidth;
  return e >= $["2xl"] ? "2xl" : e >= $.xl ? "xl" : e >= $.lg ? "lg" : e >= $.md ? "md" : e >= $.sm ? "sm" : "base";
}
const V = {
  white: "#FFFFFF",
  black: "#000000",
  dark: "#1E2022",
  "cyan-lite": "#8CCDFF",
  cyan: "#60C5FF",
  "cyan-dark": "#55E6EE",
  accent: "#00C2F3",
  muted: "#C6C6C9"
}, nl = {
  Colors: {
    "cyan-lite": V["cyan-lite"],
    cyan: V.cyan,
    "cyan-dark": V["cyan-dark"]
  },
  Background: {
    primary: V.black,
    secondary: V.dark,
    gradient: V.accent
  },
  Foreground: {
    primary: V.white,
    muted: V.muted,
    accent: V.accent
  }
};
export {
  Yn as Accordion,
  ea as AccordionContent,
  Jn as AccordionItem,
  Qn as AccordionTrigger,
  Bs as ActivityPanel,
  Zo as ActivityPanelBadge,
  Vo as ActivityPanelBody,
  Lo as ActivityPanelContent,
  Go as ActivityPanelEmptyState,
  Bo as ActivityPanelFooter,
  Oo as ActivityPanelHeader,
  Ho as ActivityPanelList,
  Fo as ActivityPanelSection,
  jo as ActivityPanelSectionHeader,
  Gs as ActivityPanelTrigger,
  Xe as Alert,
  ir as Autocomplete,
  ra as Avatar,
  da as Badge,
  Zn as Body,
  $n as BodyLarge,
  Un as BodySmall,
  Cs as BrandedAppLoader,
  z as Button,
  Hs as Callout,
  Kn as Caption,
  Wn as CaptionSmall,
  ce as Card,
  Wo as Carousel,
  Je as CarouselDots,
  Ms as CenteredSpinner,
  Ve as Checkbox,
  Ct as ChipSelect,
  qn as Code,
  lr as Combobox,
  Ws as ConfigCard,
  Us as ConfigField,
  Ks as ConfigSection,
  Js as ConfirmModal,
  is as ContextMenu,
  Wt as ContextMenuContent,
  cs as ContextMenuGroup,
  Xt as ContextMenuItem,
  Yt as ContextMenuLabel,
  us as ContextMenuRadioGroup,
  qt as ContextMenuSeparator,
  ms as ContextMenuSub,
  Qt as ContextMenuSubContent,
  Jt as ContextMenuSubTrigger,
  ds as ContextMenuTrigger,
  er as DatePicker,
  ge as Description,
  mn as Dialog,
  re as DialogBody,
  Ze as DialogContent,
  ne as DialogDescription,
  me as DialogFooter,
  ee as DialogHeader,
  U as DialogTitle,
  ys as DialogTrigger,
  Zs as DimensionSegmented,
  $s as DimensionSelect,
  Vn as Display,
  Ys as DisplayModal,
  rn as Divider,
  wa as DragHandleCell,
  fs as DropdownMenu,
  tr as DropdownMenuContent,
  gs as DropdownMenuGroup,
  rr as DropdownMenuItem,
  ar as DropdownMenuLabel,
  bs as DropdownMenuRadioGroup,
  nr as DropdownMenuSeparator,
  hs as DropdownMenuSub,
  sr as DropdownMenuSubContent,
  or as DropdownMenuSubTrigger,
  ps as DropdownMenuTrigger,
  W as EmptyState,
  Ts as EmptyStatePresets,
  ae as ErrorMessage,
  Fs as FadeIn,
  gn as FieldCard,
  wo as FieldError,
  dr as FileUpload,
  Ao as Form,
  Eo as FormActions,
  Io as FormField,
  Ye as FormLabel,
  qs as FormModal,
  Do as FormRow,
  Po as FormSection,
  Jo as GlassCard,
  B as HStack,
  On as Heading,
  Fn as Heading1,
  jn as Heading2,
  Hn as Heading3,
  Bn as Heading4,
  Gn as Heading5,
  It as Hyperlink,
  Mt as IconButton,
  mo as InfiniteScroll,
  Ke as InlineIcon,
  Ft as Input,
  Ro as Label,
  _a as LabelledContent,
  Ya as LoadingOverlay,
  Xs as MediaCardContent,
  Qo as MediaCardLayout,
  Xn as Overline,
  cr as Pagination,
  As as Popover,
  ks as PopoverAnchor,
  za as PopoverArrow,
  Ps as PopoverClose,
  Ma as PopoverContent,
  La as PopoverLabel,
  Oa as PopoverSeparator,
  Is as PopoverTrigger,
  Va as Progress,
  fr as RadioGroup,
  pr as RadioGroupItem,
  oe as RootModal,
  Nr as SearchInput,
  Be as SegmentedControl,
  Le as Select,
  jt as SelectGroup,
  Oe as SelectItem,
  Ht as SelectLabel,
  Ha as SelectionCell,
  Qs as SelectionModal,
  vs as Sheet,
  Nn as SheetContent,
  wn as SheetDescription,
  Sn as SheetFooter,
  yn as SheetHeader,
  vn as SheetTitle,
  ws as SheetTrigger,
  F as Skeleton,
  _s as SkeletonAlbumArt,
  Es as SkeletonText,
  Ds as SkeletonTrack,
  Rs as SkeletonWaveform,
  wr as Slider,
  nl as SonifyDesign,
  V as SonifyDesignColors,
  tn as Spacer,
  pe as Spinner,
  Ja as StatBar,
  no as Stepper,
  D as TEXT_COLOR_VARIANTS,
  _n as TEXT_SIZE_VARIANTS,
  Mn as TEXT_WEIGHT_VARIANTS,
  R as TEXT_WHITESPACE_VARIANTS,
  el as TabbedCard,
  ga as Table,
  ba as TableBody,
  va as TableCaption,
  fe as TableCell,
  xa as TableFooter,
  ya as TableHead,
  ha as TableHeader,
  Na as TableRow,
  xs as Tabs,
  Dr as TabsContent,
  Pr as TabsList,
  Er as TabsTrigger,
  Ge as Tag,
  Rr as TagInput,
  ie as Text,
  qr as TextArea,
  zo as Textarea,
  ao as Timeline,
  An as Toast,
  In as ToastAction,
  kn as ToastClose,
  En as ToastDescription,
  Ss as ToastProvider,
  Pn as ToastTitle,
  Tn as ToastViewport,
  Hr as Toggle,
  Ls as Tooltip,
  io as TooltipContent,
  zs as TooltipProvider,
  Os as TooltipTrigger,
  Vs as TreeView,
  Z as VStack,
  l as cn,
  co as collectAllIds,
  Jr as mapAlign,
  $e as mapGap,
  Yr as mapJustify,
  en as mapMinWidth,
  Ns as mapPosition,
  de as mapResponsiveSize,
  rl as useBreakpoint,
  Uo as useCarousel,
  tl as useFileDialog,
  js as useInfiniteScrollState,
  Ko as useSwipe
};
//# sourceMappingURL=index.js.map
